import { useState, useEffect, useRef } from 'react';
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Multiselect from 'multiselect-react-dropdown';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
import CamBankingPage from './CamBankingPage';
import CamBureauPage from './CamBureauPage';
import CustomerAssessmentNotePage from './CustomerAssessmentNotePage';
import CamApprovalHistoryPage from './CamApprovalHistoryPage';
import DisbursementMemoPage from './DisbursementMemoPage';
import DedupePage from './DedupePage';
import CamVisibilityPage from './CamVisibilityPage';
import CamEnachDetailsPage from './CamEnachDetailsPage';
import UsedVehiclePage from './UsedVehiclePage';
import FleetDetails from './FleetDetails';
import GstSheet from './GstSheet';
import FleetViability from './FleetViability';
import FinancialSheet from './FinancialSheet';
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------
const CamPage = (props) => {
  const { leadId, id } = useParams();
  const location = useLocation();
  const {leadInfo, actions, usersData, userInfo, fetchLeadIdBankStatement,isActive,userRoleType,camLatestStatus,allLeadBankStatementCount,setEnableCamDetailsStatus,backToLeadHandler,enableCamDetailsHandler ,vivritiChecklistStatusHandler,fetchLeads, selectionVersioningID, lead_profile: leadProfile, leadFieldPermissions} = props;

  // CAM add permission
  const hasAddPermission = !!leadFieldPermissions?.cam?.add;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate();
  const [anchorCategories, setAnchorCategories] = useState([]);  
  const [getLeadId, setLeadId] = useState('');
  const [leadBankStatementId, setLeadBankStatementId] = useState('');// table id
  const [allLeadBankStatementByLeadData, setAllLeadBankStatementByLeadData] = useState([]);
 // const [allLeadBankStatementCount, setallLeadBankStatementCount] = useState([]);
  const [file, setFile] = useState('');
  const [totalAmountAsPerPerformInvoice, setTotalAmountAsPerPerformInvoice] = useState(0);
  const [irrExcludingPF, setIrrExcludingPF] = useState(0);
  const [camIRRExcludingPF, setCamIRRExcludingPF] = useState(0);
  const [noOfAssetsToBeFinanced, setNoOfAssetsToBeFinanced] = useState(1);
  const [iRRLTVPercentage, setIRRLTVPercentage] = useState(0);
  const [cAMLTVPercentage, setCAMLTVPercentage] = useState(0);
  const [iRREMIValue, setIRREMIValue] = useState(0);
  const [iRRTotalInterest, setIRRTotalInterest] = useState(0);
  const [iRRTotalPrincipal, setIRRTotalPrincipal] = useState(0);
  const [iRRTotalRepayment, setIRRTotalRepayment] = useState(0);
  const [camTotalPFAmount, setCamTotalPFAmount] = useState(0);
  
  const [speciallyAbledArr, setSpeciallyAbledArr] = useState([]);
  const [residenceTypesArr, setResidenceTypesArr] = useState([]);
  const [bankingUpiArr, setBankingUpiArr] = useState([]);
  const [drivingLicenseTypeMasterArr, setDrivingLicenseTypeMasterArr] = useState([]);
  const [constitutionArr, setConstitutionArr] = useState([]);
  const [customerTypeArr, setCustomerTypeArr] = useState([]);
  const [vehicleMakerArr, setVehicleMakerArr] = useState([]);
  const [vehicleUseArr, setVehicleUseArr] = useState([]);
  const [insuranceArr, setInsuranceArr] = useState([]);
  const [vehicleModelsArr, setVehicleModelsArr] = useState([]);
  const [businessValidationProofArr, setBusinessValidationProofArr] = useState([]);
  const [turnoverIncomeArr, setTurnoverIncomeArr] = useState([]);
  const [workingCapitalCycleArr, setWorkingCapitalCycleArr] = useState([]);
  const [addedLeadCoapplicantGuarantorRows, setAddedLeadCoapplicantGuarantorRows] = useState([]);
  const [coapplicantGuarantorRows, setCoapplicantGuarantorRows] = useState([]);
  const [accountTypeArr, setAccountTypeArr] = useState([]);
  const [crifDetails, setCrifDetails] = useState([]);  
  const [bankDetails, setBankDetails] = useState([]); 
  const [dedupeMatchesDetails, setDedupeMatchesDetails] = useState([]); 
  const [camApprovalHistory, setCamApprovalHistory] = useState([]);
  const [camCustomerDedupeHistory, setCamCustomerDedupeHistory] = useState([]);
  const [runCustomerDedupeHistory, setRunCustomerDedupeHistory] = useState([]);  
  
  const [cAMMarginMoney, setCAMMarginMoney] = useState(0);
  const [annualIrr, setAnnualIrr] = useState(null);
  const [error, setError] = useState(null);
  const [showCamNote, setShowCamNote] = useState('');
  const [showCamCustomerDedupeNote, setShowCamCustomerDedupeNote] = useState('');
  const [camApproveLatestStatus, setCamApproveLatestStatus] = useState(0);
  const [camCustomerDedupeLatestStatus, setCamCustomerDedupeLatestStatus] = useState(0);
  const [selectedMailDocuments, setSelectedMailDocuments] =useState("");
   const [allDealersArr, setAllDealersArr] = useState([]);
   
   const [rsmRhChLatestHistoryData, setRsmRhChLatestHistoryData] = useState([]);

  const formRef = useRef(null);
  const [camCategories, setCamCategories] = useState([{ 'id': '1', 'name': "Other" }, { 'id': '2', 'name': "Other 2" }]);

  const [normsMetOptions, setNormsMetOptions] = useState([{ 'id': '1', 'name': "Met" }, { 'id': '2', 'name': "Not Met" }, { 'id': '3', 'name': "NA" }]);

  const [requirementOptions, setRequirementOptions] = useState([{ 'id': '1', 'name': "Not Applicable" }, { 'id': '2', 'name': "Applicable" }]);

  const [statusOptions, setStatusOptions] = useState([{ 'id': '1', 'name': "Applicable" }, { 'id': '2', 'name': "Not Applicable" }]);

  const [approveBtnAction, setApproveBtnAction] = useState(0);
  const [openRejectAmt, setOpenRejectAmt] = useState(false);

  const [approveBtnDedupeAction, setApproveBtnDedupeAction] = useState(0);
  const [openDedupe, setOpenDedupe] = useState(false);

  const [proposedRejectAmt, setproposedRejectAmt] = useState('');
  const [noOfAssetsToBeFinancedAfter, setNoOfAssetsToBeFinancedAfter] = useState('');
  const [multiofTotalAssetsNoofAssets, SetMultiofTotalAssetsNoofAssets] = useState('');
  const [totalValueCombine, setTotalValueCombine] = useState(noOfAssetsToBeFinancedAfter * totalAmountAsPerPerformInvoice);
  // const [totalValueCombine, setTotalValueCombine] = useState('');

  const [isReadyToModify, setIsReadyToModify] = useState(true);

  const [dealerAddress, setDealerAddress] = useState('');
  const [dealerName, setDealerName] = useState('');
  const [dealerBenificaryName, setDealerBenificaryName] = useState('');
  const [dealerBankName, setDealerBankName] = useState('');
  const [dealerAccountNo, setDealerAccountNo] = useState('');
  const [dealerIfsc, setDealerIfsc] = useState(''); 
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  
const [selectedRecipients, setSelectedRecipients] = useState([]);
const cameraInputRef = useRef(null);
const [showCameraModal, setShowCameraModal] = useState(false);
const videoRef = useRef(null);
const streamRef = useRef(null);
const [messageBody, setMessageBody] = useState('');
const [mailSubject, setMailSubject] = useState('');
const [communicationHistory, setCommunicationHistory] = useState([]);
const [attachments,setAttachments] = useState([]);

const [staticRecipients, setStaticRecipients] = useState([]);
const [openMailModal,setOpenMailModal] = useState(false);
const [selectedMailBody,setSelectedMailBody] = useState("");
const [previewImage, setPreviewImage] = useState("");
const [isUsedVehicle, setIsUsedVehicle] = useState(false);

  const [formCAMValues, setFormCAMValues] = useState({
    addressTypeId: '1',
    assets_no_of_vehicles_to_be_finance:'1',
    assets_chassis_cost_closed_body:'0.00',
    assets_chassis_cost_open_body:'0.00',
    assets_body_cost_including_gst:'0.00',
    assets_body_cost_excluding_gst:'0.00',
    assets_insurance_by_dealer:'0.00',
    assets_insurance_by_customer_ckers:'0.00',
    assets_handling_charges:'0.00',
    assets_registration_charges_including_gst:'0.00',
    assets_febrication:'0.00',
    assets_kli:'0.00',
    assets_amc:'0.00',
    assets_gps_device_iot_device_charges:'0.00',
    assets_charger_cost_hp:'0.00',
    assets_other_charges_if_any:'0.00',
    assets_discount:'0.00',
    irr_total_asset_price:'',
    irr_no_of_assets_to_be_financed:'',
    irr_total_value_of_combined_asset:'',
    irr_finance_amount:'',
    irr_ltv_percentage:'',
    irr_flat_rate:'',
    irr_no_of_years:'',
    irr_no_of_emi:'',
    irr_emi_value:'0.00',
    irr_excluding_pf:'',
    irr_total_interest:'',
    irr_total_principal:'',
    irr_total_repayment:'',

    // Used Loan IRR Sheet Fields
    used_irr_dp_margin: '',
    used_irr_pf_fund_in_la: '',
    used_irr_pf_percentage: '',
    used_irr_total_finance_amount: '0.00',
    used_irr_revised_loan_amount: '0.00',
    used_irr_adjust_pf_old_loan: '0.00',
    used_irr_pf_amount: '0.00',
    used_irr_gst_amount: '0.00',
    used_irr_total_pf_amount: '0.00',
    used_irr_chassis_cost_deal_close: '0.00',
    used_irr_insurance_by_customer_ckers: '',

    cam_customer_name:"",
    cam_pan_no:"",
    cam_category:"",
    cam_sales_manager:"",
    cam_no_of_vehicles_owned:"",
    cam_gender:"Male",
    cam_specially_abled:'No',
    cam_contact_person_name_designation:"",
    cam_address:"",
    cam_permanent_landmark : "",
    cam_permanent_city : "",
    cam_permanent_district : "",
    cam_permanent_state : "",
    cam_permanent_pin : "",
    cam_mobile_no:"",
    cam_repayment_mode:"ENACH",
    cam_credit_free_vehicle:"",
    cam_social_category:"",
    cam_spouse:"",
    cam_father_name:"",
    cam_dob:"",
    cam_cibil_crif:"",
    cam_residence_type:"Owned",
    cam_current_address_and_city_stability:"",
    cam_education:"",
    cam_source:"",
    cam_file_charges:"1000",
    cam_kotak_li_amount:"",
    cam_who_is_driver:"",
    cam_driving_license_type:"",
    cam_dl:"",
    cam_banking_upi:"",
    cam_lender:"cKers",
    cam_vehicle_type:"New",
    cam_vehicle_use_open:"",
    cam_consolidated_emi:"",
    cam_email_id:"",
    cam_constitution:"",
    cam_customer_type:"",
    cam_vehicle_maker:"",
    cam_emi_per_vehicle:"",
    cam_free_vehicle_percentage:"",
    cam_additional_source_of_income:"",
    cam_vehicle_use:"",
    cam_insurance:"",
    cam_vehicle_models:"",
    cam_dealer_name:"",
    cam_loan_tenor_in_months:"",
    cam_payout:"",
    cam_pf:"",
    cam_iarr:"",
    cam_location:"",
    cam_asset_cost:"",
    cam_no_of_asset:"",
    cam_total_cost:"",
    cam_finance_value:"",
    cam_ltv:"0.00",
    cam_margin_money:"",
    cam_pf_amount:"",
    cam_flat_irr:"",
    cam_addhar_no:"",
    cam_reference_name_1:"",
    cam_reference_address_1:"",
    cam_reference_relationship_1:"",
    cam_reference_phone_1:"",
    cam_reference_name_2:"",
    cam_reference_address_2:"",
    cam_reference_relationship_2:"",
    cam_reference_phone_2:"",
    remarks_business_profile:"",
    remarks_major_activity:"",
    remarks_business_vintage:"",
    remarks_business_validation_proof:"",
    remarks_turnover_income:"",
    remarks_working_capital_cycle:"",
    remarks_credit_bureau_remarks_commercial:"",
    remarks_work_order_contracts:"",

    remarks_bank_name:"",
    remarks_account_holder_name:"",
    remarks_account_no:"",
    remarks_ifsc_code:"",
    remarks_type_of_account:"",
    remarks_abb_utilization:"",
    remarks_total_credits:"",
    remarks_iw_rtn_per_and_count:"",
    remarks_ow_rtn_per_and_count:"",
    remarks_notes:"Active with decent ABB",
    remarks_previous_em_ii_uam:"No",

    remarks_existing_loan_details:"",
    remarks_credit_bureau_remarks:"",
    remarks_current_vehicle_deployment:"",
    remarks_financials_related_remark:"",

    dilligence_pd_requirement:"",
    dilligence_pd_status:"",
    dilligence_pd_remarks:"",
    dilligence_proformainvoice_requirement:"",
    dilligence_proformainvoice_status:"",
    dilligence_proformainvoice_remarks:"",
    dilligence_kyc_requirement:"",
    dilligence_kyc_status:"",
    dilligence_kyc_remarks:"",
    dilligence_banking_requirement:"",
    dilligence_banking_status:"",
    dilligence_banking_remarks:"",
    dilligence_gst_requirement:"",
    dilligence_gst_status:"",
    dilligence_gst_remarks:"",
    dilligence_financials_requirement:"",
    dilligence_financials_status:"",
    dilligence_financials_remarks:"",

    dp_npc_standard_criteria:"",
    dp_npc_norms:"",
    dp_npc_deviation_approval:"",
    dp_npc_mitigation:"",
    dp_cfvif_standard_criteria:"",
    dp_cfvif_norms:"",
    dp_cfvif_deviation_approval:"",
    dp_cfvif_mitigation:"",
    dp_aievcr_standard_criteria:"",
    dp_aievcr_norms:"",
    dp_aievcr_deviation_approval:"",
    dp_aievcr_mitigation:"",
    dp_maxltv_standard_criteria:"",
    dp_maxltv_norms:"",
    dp_maxltv_deviation_approval:"",
    dp_maxltv_mitigation:"",
    dp_stabilitytic_standard_criteria:"",
    dp_stabilitytic_norms:"",
    dp_stabilitytic_deviation_approval:"",
    dp_stabilitytic_mitigation:"",
    dp_pwstability_standard_criteria:"",
    dp_pwstability_norms:"",
    dp_pwstability_deviation_approval:"",
    dp_pwstability_mitigation:"",
    dp_rcpgls_standard_criteria:"",
    dp_rcpgls_norms:"",
    dp_rcpgls_deviation_approval:"",
    dp_rcpgls_mitigation:"",
    dp_bsde_standard_criteria:"",
    dp_bsde_norms:"",
    dp_bsde_deviation_approval:"",
    dp_bsde_mitigation:"",
    dp_nw_standard_criteria:"",
    dp_nw_norms:"",
    dp_nw_deviation_approval:"",
    dp_nw_mitigation:"",
    dp_dc_standard_criteria:"",
    dp_dc_norms:"",
    dp_dc_deviation_approval:"",
    dp_dc_mitigation:"",
    dp_bureaucheck_standard_criteria:"",
    dp_bureaucheck_norms:"",
    dp_bureaucheck_deviation_approval:"",
    dp_bureaucheck_mitigation:"",
    dp_bankingcriteria_standard_criteria:"",
    dp_bankingcriteria_norms:"",
    dp_bankingcriteria_deviation_approval:"",
    dp_bankingcriteria_mitigation:"",
    dp_gstcriteria_standard_criteria:"",
    dp_gstcriteria_norms:"",
    dp_gstcriteria_deviation_approval:"",
    dp_gstcriteria_mitigation:"",
    dp_financialcriteria_standard_criteria:"",
    dp_financialcriteria_norms:"",
    dp_financialcriteria_deviation_approval:"",
    dp_financialcriteria_mitigation:"",
    dp_acfsc_standard_criteria:"",
    dp_acfsc_norms:"",
    dp_acfsc_deviation_approval:"",
    dp_acfsc_mitigation:"",
    
    dmemo_reference_no:"",
    dmemo_date:"",
    dmemo_pre_emi_start_date:"",
    dmemo_pre_emi_end_date:"",
    dmemo_agreement_no:"",
    dmemo_sourcing_agency :"",
    dmemo_customer_name:"",
    dmemo_guarantor_name:"",
    dmemo_guarantor_name_2:"",
    dmemo_vehicle_models:"",
    dmemo_no_of_asset:"",
    dmemo_invoice_price_per_vehicle:"",
    dmemo_invoice_price_all_vehicle:'',
    dmemo_total_cost_per_vehicle:"",
    dmemo_margin_money_vehicle:'',
    dmemo_margin_money_all_vehicle: "",
    dmemo_total_down_payment_by_customer:"",
    dmemo_funding_per_vehicle:'',
    dmemo_loan_amount:'',
    dmemo_ltv:'',
    dmemo_tenure:'',
    dmemo_emi_per_vehicle:'',
    dmemo_emi_all_vehicle:'',
    dmemo_scheme:'',
    dmemo_no_of_advance_emi:'',
    dmemo_processing_fee_including_gst:'',
    dmemo_processing_fee_including_gst_type:'Upfront Collection',
    dmemo_insurance_by_cfpl:'',
    dmemo_insurance_by_dealer:'',
    dmemo_stamp_duty:'',
    dmemo_directs_ource_charges:'',
    dmemo_dealer_subvention:'',
    dmemo_disbursement_date:'',
    dmemo_first_emi_interest_date:'',
    dmemo_pre_emi:'',
    dmemo_pre_emi_type :'Upfront Collection',
    dmemo_kli_amount:'',
    dmemo_kli_amount_type :'Upfront Collection',
    dmemo_file_charge:'',
    dmemo_file_charge_type : 'Upfront Collection',
    dmemo_flat_rate:'',
    dmemo_irr:'',
    dmemo_disbursement_amount_for_vehicle_including_box:'',
    dmemo_disbursement_in_vehicle_in_favour_of:'',
    dmemo_bank_name:'',
    dmemo_account_no:'',
    dmemo_ifsc_code:'',
    dmemo_signature_of_operations:'',
    dmemo_maker_by:'',
    dmemo_authorised_by:'',
    dmemo_processing_fee_on_finance_amount_plus_gst:'',
    dmemo_less_pre_emi_till_5th_jan:'',
    dmemo_net_disbursement:'',
  });

  const [formCAMRSMRHCHValues, setFormCAMRSMRHCHValues] = useState({
    rsm_rh_ch_review: '',
    rsm_rh_ch_remarks: '',    
  });

  const roundNumber = (num) => {
    if (!num && num !== 0) return 0; 
    return Math.round(num);
  };
 
    const userInfos = useSelector((state) => state.userInfo);
    const useremail = userInfos.email;
      // console.log("my dataaaaaaaa", useremail);
    
    const userId = userInfos?.id;

  function calculatePMT(rate, nper, pv,formData) {
    rate = rate / 100 / 12; // Convert annual interest rate to monthly
    let spliteEmi = 0;
    if(formData.dmemo_pre_emi_type === 'Merge with EMI'){
      const dmemoPreEmiAmount = formData?.dmemo_pre_emi || 0;
      const dmemoTenure = formData?.dmemo_tenure || 0; 
      spliteEmi = (dmemoTenure !== 0) ? dmemoPreEmiAmount / dmemoTenure : 0;

     // console.log("spliteEmi = ",spliteEmi);
    }
    let outPut = (pv * rate) / (1 - (1 + rate) ** -nper);

    outPut += Number(spliteEmi); 
    return roundNumber(outPut);
  }

  function calculateValue(value,percentage) {
    const roundedUp = Math.ceil(value * percentage); // ROUNDUP equivalent

    const output = roundNumber((roundedUp / 100) * 1.18);
    return output; 
  }

  function calculateInterest(amount, rate, start, end) {
    const startDt = new Date(start);
    const endDt = new Date(end);
    // const daysDiff = (startDt - endDt) / (1000 * 60 * 60 * 24); // Convert milliseconds to days
    const daysDiff = (endDt - startDt) / (1000 * 60 * 60 * 24); // Convert milliseconds to days
   // console.log("daysDiff = ",daysDiff);
    
    
   // const interest = Math.ceil((amount * rate / 100) / 360 * daysDiff); // Apply ROUNDUP
    const interest = Math.round((amount * rate / 100) / 360 * daysDiff); // Apply ROUNDUP

   // console.log("interest = ",interest);
    const output =  roundNumber(interest);
    return output; // Apply negative sign
  }


  function calculateIRR(cashFlows, guess = 0.1) {
    const maxIterations = 1000; // Maximum iterations to avoid infinite loop
    const precision = 1.0e-7;   // Precision for convergence

    let currentGuess = guess;

    for (let i = 0; i < maxIterations; i += 1) {
        let npv = 0.0;          // Net Present Value
        let derivative = 0.0;   // Derivative of NPV (for Newton-Raphson)

        for (let t = 0; t < cashFlows.length; t += 1) {
          const cashFlow = cashFlows[t];
          npv += cashFlow / ((1 + currentGuess) ** t);
          derivative += -t * cashFlow / ((1 + currentGuess) ** (t + 1));
        }

        if (Math.abs(derivative) < precision) {
            break;
        }

        const newGuess = currentGuess - npv / derivative;

        if (Math.abs(newGuess - currentGuess) < precision) {
            return newGuess; // Return monthly IRR
        }

        // Update the guess for the next iteration
        currentGuess = newGuess;
    }

    return null; // Return null if IRR cannot be calculated
}

  const updateDeviationsValues = (name, value) => {
    if(name ==='dp_npc_norms' ){
      formCAMValues.dp_npc_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_npc_deviation_approval = 'NA';
      }
    }

    if(name ==='dp_cfvif_norms' ){
      formCAMValues.dp_cfvif_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_cfvif_deviation_approval = 'L5';
      }
    }

    if(name ==='dp_aievcr_norms' ){
      formCAMValues.dp_aievcr_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_aievcr_deviation_approval = 'NA';
      }
    }

    if(name ==='dp_maxltv_norms' ){
      formCAMValues.dp_maxltv_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_maxltv_deviation_approval = 'Credit Head';
      }
    }
    if(name ==='dp_stabilitytic_norms' ){
      formCAMValues.dp_stabilitytic_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_stabilitytic_deviation_approval = 'Credit Head';
      }
    }
    if(name ==='dp_pwstability_norms' ){
      formCAMValues.dp_pwstability_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_pwstability_deviation_approval = 'Credit Head';
      }
    }

    if(name ==='dp_rcpgls_norms' ){
      formCAMValues.dp_rcpgls_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_rcpgls_deviation_approval = 'NA';
      }
    }

    if(name ==='dp_bsde_norms' ){
      formCAMValues.dp_bsde_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_bsde_deviation_approval = 'Credit Head';
      }
    }
    if(name ==='dp_nw_norms' ){
      formCAMValues.dp_nw_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_nw_deviation_approval = 'Credit Head';
      }
    }
    if(name ==='dp_dc_norms' ){
      formCAMValues.dp_dc_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_dc_deviation_approval = 'NA';
      }
    }
    if(name ==='dp_bureaucheck_norms' ){
      formCAMValues.dp_bureaucheck_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_bureaucheck_deviation_approval = 'NA';
      }
    }
    if(name ==='dp_bankingcriteria_norms' ){
      formCAMValues.dp_bankingcriteria_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_bankingcriteria_deviation_approval = 'Credit Head';
      }
    }
    if(name ==='dp_gstcriteria_norms' ){
      formCAMValues.dp_gstcriteria_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_gstcriteria_deviation_approval = 'Credit Head';
      }
    }

    if(name ==='dp_financialcriteria_norms' ){
      formCAMValues.dp_financialcriteria_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_financialcriteria_deviation_approval = 'Credit Head';
      }
    }
    if(name ==='dp_acfsc_norms' ){
      formCAMValues.dp_acfsc_deviation_approval = '';
      if(value === '2'){
        formCAMValues.dp_acfsc_deviation_approval = 'Credit Head+Business Head';
      }
    }



  };

   const handleCAMRSMRHCHChange = (e) => {
     const { name, value } = e.target; 
     
      setFormCAMRSMRHCHValues({
          ...formCAMRSMRHCHValues,
          [name]: value,
      });  
   }

    const handleRSMRHCHDetails = () => {

       const decodedId = atob(id);
      
         const params = { lead_id: decodedId, formData: formCAMRSMRHCHValues, "userRoleType" : userRoleType };
            const requestData = encryptData(params);
            const response = actions.saveRSMRHCHDetails(requestData);
        
            response
              .then((result) => { 
                if (result.data.success === 1) {
                  // console.log("karza pan response = ", result.data.data);
                   
                    setPreloaderStatus(false);
                    toast.success(result.data.message, {
                      position: "top-right",
                    }); 
                   
                } else {
                  setPreloaderStatus(false);
                  toast.error(result.data.message, {
                    position: "top-right",
                  });
                }
              })
              .catch((error) => {
                setPreloaderStatus(false);
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                  position: "top-right",
                });
              });
    }

    const getUserEmails = async () => {
    try {

        const response = await fetch(
            `${config.API_BASE_URL}getuseremail`
        );

        const result = await response.json();

        console.log(result);

        if(result.status){

            const users = result.data.map(item => ({
                label: item.name,
                value: item.email
            }));

            setStaticRecipients(users);
        }

    } catch(error){
        console.log(error);
    }
    };
        useEffect(() => {
          getUserEmails();
        }, []);

useEffect(() => {

  const resizeHandler = (e) => {

    if (
      e.message?.includes(
        "ResizeObserver"
      )
    ) {

      e.preventDefault();
      e.stopImmediatePropagation();
    }

    return null;

  };

  window.addEventListener(
    "error",
    resizeHandler,
    true
  );

  return () => {
    window.removeEventListener(
      "error",
      resizeHandler,
      true
    );
  };

}, []);

    const getCommunicationHistory = async () => {

    try {

        if(!id) return;

        const decodedId = atob(id);

        const response = await fetch(
            `${config.API_BASE_URL}get_communication_history?lead_id=${decodedId}`
        );

        const result = await response.json();

        console.log(
            "Communication History =>",
            result
        );

        if (
            result.success === 1 ||
            result.status === 1
        ) {

            setCommunicationHistory(
                result.data || []
            );

        } else {

            setCommunicationHistory([]);

        }

    } catch(error){

        console.log(
            "Communication History Error =>",
            error
        );

        setCommunicationHistory([]);
    }
};

useEffect(() => {

    if(!id) return undefined;

    getCommunicationHistory();

    const interval = setInterval(() => {
        getCommunicationHistory();
    }, 5000);

    return () => clearInterval(interval);

}, [id]);


const sendCommunicationMail = async () => {

    const decodedId = atob(id);

    const formData = new FormData();

    formData.append(
        "lead_id",
        decodedId
    );

    formData.append(
        "emails",
        JSON.stringify(
            selectedRecipients
        )
    );

    formData.append(
        "subject",
        mailSubject
    );

    formData.append(
        "note",
        messageBody
    );

    formData.append(
        "created_by",
        userId
    );

    attachments.forEach(file => {

        formData.append(
            "attachments[]",
            file
        );

    });

    try {

        // START LOADER
        setPreloaderStatus(true);

        const response = await fetch(
            `${config.API_BASE_URL}send_communication_mail`,
            {
                method: "POST",
                body: formData
            }
        );

        const result =
            await response.json();

        console.log(
            result
        );

        if(
            result.success === 1 ||
            result.status === 1
        ){

            setSelectedRecipients(
                []
            );

            setMailSubject("");

            setAttachments(
                []
            );

            setTimeout(() => {

                setMessageBody("");

            },100);

            await getCommunicationHistory();

            toast.success(
                "Communication sent successfully"
            );

        }else{

            toast.error(
                result.message ||
                "Failed to send communication"
            );
        }

    } catch(error){

        console.log(error);

        toast.error(
            "Something went wrong"
        );

    } finally {

        // SUCCESS / ERROR DONO ME CLOSE
        setPreloaderStatus(
            false
        );
    }
};


const startCamera = async () => {
  setShowCameraModal(true);
  setTimeout(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
      videoRef.current.srcObject = stream;
      streamRef.current = stream;
    } catch (err) {
      toast.error("Camera access denied!", { position: "top-right" });
      setShowCameraModal(false);
    }
  }, 100);
};

const stopCamera = () => {
  streamRef.current?.getTracks().forEach(track => track.stop());
  setShowCameraModal(false);
};

const capturePhoto = () => {
  const canvas = document.createElement("canvas");
  canvas.width = videoRef.current.videoWidth;
  canvas.height = videoRef.current.videoHeight;
  canvas.getContext("2d").drawImage(videoRef.current, 0, 0);
  canvas.toBlob((blob) => {
    const file = new File([blob], `photo_${Date.now()}.jpg`, { type: "image/jpeg" });
    setAttachments(prev => [...prev, file]);
    stopCamera();
  }, "image/jpeg");
};

 
  const handleCAMChange = (e) => {
      const { name, value } = e.target;

      if(e.target.name ==='cam_dealer_name'){
            const dealerInfo = allDealersArr.find(doc => doc.name === e.target.value);
           // setRefDoNo(event.target.value);
              setDealerName(dealerInfo?.name);

              setDealerAddress(dealerInfo?.address);
              setDealerBankName(dealerInfo?.bank_name);
              setDealerAccountNo(dealerInfo?.account_no);
              setDealerIfsc(dealerInfo?.ifsc);
              setDealerBenificaryName(dealerInfo?.benificary_name);

              autoUpdateField("dmemo_disbursement_in_vehicle_in_favour_of", dealerInfo?.benificary_name);
              autoUpdateField("dmemo_bank_name", dealerInfo?.bank_name);
              autoUpdateField("dmemo_account_no", dealerInfo?.account_no);
              autoUpdateField("dmemo_ifsc_code", dealerInfo?.ifsc);
        }



      updateDeviationsValues(name , value);

      setFormCAMValues({
          ...formCAMValues,
          [name]: value,
      });

      // Trigger calculations for specific fields that affect totals
      // Using setTimeout to avoid synchronous state update loops
      if (name.startsWith('assets_') || name.startsWith('irr_') || name.startsWith('cam_')) {
        setTimeout(() => {
          camFormCalculations();
        }, 0);
      }

  }; 

  const autoUpdateField = (fieldName, value) => {
    setFormCAMValues((formCAMValues) => ({
      ...formCAMValues,  
      [fieldName]: value,  
    }));
  };

  const camCommercialsCalculations = () =>{
     
    let camTotalCost = 0;
    
      let camNoOfAsset = 0;
      let camAssetCost = 0;
      if(formCAMValues.cam_no_of_asset !==''){
        camNoOfAsset = parseFloat(formCAMValues.cam_no_of_asset) || 0;
      }
      if(formCAMValues.cam_asset_cost !==''){
        camAssetCost = parseFloat(formCAMValues.cam_asset_cost) || 0;
      }
      camTotalCost =   camNoOfAsset * camAssetCost;
      autoUpdateField("cam_total_cost", camTotalCost.toFixed(2));

      let irrFinanceAmount = 0;
      if(formCAMValues.irr_finance_amount !==''){
        irrFinanceAmount = parseFloat(formCAMValues.irr_finance_amount) || 0;
      }
      
      if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1) {
        irrFinanceAmount = parseFloat(formCAMValues.used_irr_total_finance_amount) || 0;
      }
      
      const camTotalFinanceAmount =   camNoOfAsset * irrFinanceAmount;       
      autoUpdateField("cam_finance_value", camTotalFinanceAmount.toFixed(2));
      
      const camFinanceAmount = parseFloat(formCAMValues?.cam_finance_value?.replace(/\s/g, "")) || 0;
      const camLTVPercentage = (camFinanceAmount / camTotalCost) * 100;
      setCAMLTVPercentage(camLTVPercentage);
      autoUpdateField("cam_ltv", camLTVPercentage.toFixed(2));
      autoUpdateField("dmemo_ltv", camLTVPercentage.toFixed(2));
  };

  
  const setDefaultFieldsValues = () => {
    if (props.leadInfo && props.leadInfo.data && Array.isArray(props.leadInfo.data) && props.leadInfo.data.length > 0) { 
        if(formCAMValues.cam_customer_name === ''){
          autoUpdateField("cam_customer_name", props.leadInfo.data[0].name);
        } 

        if(formCAMValues.cam_dealer_name === ''){
          autoUpdateField("cam_dealer_name", props.leadInfo.data[0].dealer_name);
          setDealerName(props.leadInfo.data[0].dealer_name); 
        } 
           
           if(formCAMValues.cam_dealer_name !==''){
            const dealerInfo = allDealersArr.find(doc => doc.name === formCAMValues.cam_dealer_name);
           // setRefDoNo(event.target.value);
              setDealerName(dealerInfo?.name); 

              setDealerAddress(dealerInfo?.address);
              setDealerBankName(dealerInfo?.bank_name);
              setDealerAccountNo(dealerInfo?.account_no);
              setDealerIfsc(dealerInfo?.ifsc);
              setDealerBenificaryName(dealerInfo?.benificary_name); 
  
              autoUpdateField("dmemo_disbursement_in_vehicle_in_favour_of", dealerInfo?.benificary_name);
              autoUpdateField("dmemo_bank_name", dealerInfo?.bank_name);
              autoUpdateField("dmemo_account_no", dealerInfo?.account_no);
              autoUpdateField("dmemo_ifsc_code", dealerInfo?.ifsc);
         }

        if(formCAMValues.dmemo_customer_name === ''){
          autoUpdateField("dmemo_customer_name", props.leadInfo.data[0].name);
        } 

        if(formCAMValues.dmemo_vehicle_models === ''){
          autoUpdateField("dmemo_vehicle_models", formCAMValues.cam_vehicle_models);
        } 

        if(formCAMValues.cam_pan_no === '' && Object.prototype.hasOwnProperty.call(props.leadInfo.data[0], 'pancard_number') && props.leadInfo.data[0].pancard_number !== '' && props.leadInfo.data[0].pancard_number !== null){
          const panNumber = props.leadInfo.data[0].pancard_number.replace(/"/g, '');
          autoUpdateField("cam_pan_no", panNumber);
        }  

        if(formCAMValues.cam_addhar_no === '' && Object.prototype.hasOwnProperty.call(props.leadInfo.data[0], 'adhar_number') && props.leadInfo.data[0].adhar_number !== '' && props.leadInfo.data[0].adhar_number !== null){
           autoUpdateField("cam_addhar_no", props.leadInfo.data[0].adhar_number);
        }  
        
        if(formCAMValues.cam_sales_manager === '' && Object.prototype.hasOwnProperty.call(props.leadInfo.data[0], 'leadAssigned') && props.leadInfo.data[0].leadAssigned !== '' && props.leadInfo.data[0].leadAssigned !== null){
           autoUpdateField("cam_sales_manager", props.leadInfo.data[0].leadAssigned);
        } 


        
        if(( formCAMValues.cam_vehicle_type === '' || formCAMValues.cam_vehicle_type === undefined) && Object.prototype.hasOwnProperty.call(props.leadInfo.data[0], 'vehicle_type') && props.leadInfo.data[0].vehicle_type !== '' && props.leadInfo.data[0].vehicle_type !== null){
           autoUpdateField("cam_vehicle_type", props.leadInfo.data[0].vehicle_type);
        }
        
        if(formCAMValues.cam_iarr === ''){
          autoUpdateField("cam_iarr", irrExcludingPF.toFixed(2));
        } 
        
       // if(formCAMValues.cam_no_of_vehicles_owned === ''){
          autoUpdateField("cam_no_of_vehicles_owned", noOfAssetsToBeFinanced);
      //  } 

        if(formCAMValues.cam_no_of_asset === ''){
          autoUpdateField("cam_no_of_asset", noOfAssetsToBeFinanced);
        } 

        if(formCAMValues.cam_asset_cost === ''){
          autoUpdateField("cam_asset_cost", totalAmountAsPerPerformInvoice.toFixed(2));
        } 

        // if(formCAMValues.irr_total_asset_price === ''){
        //  autoUpdateField("irr_total_asset_price", totalAmountAsPerPerformInvoice.toFixed(2));
         

        //   const dealValue = parseFloat(totalAmountAsPerPerformInvoice.toFixed(2) || 0);
        //   const dpMargin = parseFloat(formCAMValues.used_irr_dp_margin || 0);
        //   const consideringLoanAmount = dealValue - dpMargin;
        //   autoUpdateField("irr_finance_amount", consideringLoanAmount.toFixed(2));

        
        // }

        autoUpdateField("irr_total_asset_price", totalAmountAsPerPerformInvoice.toFixed(2));

        if(formCAMValues.irr_finance_amount === ''){
          const dealValue = parseFloat(totalAmountAsPerPerformInvoice.toFixed(2) || 0);
          const dpMargin = parseFloat(formCAMValues.used_irr_dp_margin || 0);
          const consideringLoanAmount = dealValue - dpMargin;
          autoUpdateField("irr_finance_amount", consideringLoanAmount.toFixed(2));
        }

        // Used Loan : Chassis Cost (Deal Close) & Insurance by Customer/cKers - Assets Details tab se read-only mirror
        if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1) {
          autoUpdateField("used_irr_chassis_cost_deal_close", formCAMValues.assets_chassis_cost_closed_body || '0.00');
          autoUpdateField("used_irr_insurance_by_customer_ckers", formCAMValues.assets_insurance_by_customer_ckers || '0.00');
        }
        
        
        let camTotalCost = 0;
        if(formCAMValues.cam_total_cost === ''){
          let camNoOfAsset = 0;
          let camAssetCost = 0;
          if(formCAMValues.cam_no_of_asset !==''){
            camNoOfAsset = parseFloat(formCAMValues.cam_no_of_asset) || 0;
          }
          if(formCAMValues.cam_asset_cost !==''){
            camAssetCost = parseFloat(formCAMValues.cam_asset_cost) || 0;
          }
          camTotalCost =   camNoOfAsset * camAssetCost;
          autoUpdateField("cam_total_cost", camTotalCost.toFixed(2));
         } 
 
       
        if(formCAMValues.cam_dob === ''  && Object.prototype.hasOwnProperty.call(props.leadInfo.data[0], 'dob') && props.leadInfo.data[0].dob !== '' && props.leadInfo.data[0].dob !== null){
          autoUpdateField("cam_dob", props.leadInfo.data[0].dob);
        } 
        
        if(formCAMValues.cam_finance_value === ''){
          autoUpdateField("cam_finance_value", iRRTotalPrincipal.toFixed(2));
        } 

        if(formCAMValues.cam_ltv === ''){
          autoUpdateField("cam_ltv", iRRLTVPercentage.toFixed(2));
          autoUpdateField("dmemo_ltv", iRRLTVPercentage.toFixed(2));
        } 
       

      //  if (formCAMValues.cam_margin_money === '' && formCAMValues.cam_total_cost !== '') {

          const camTotalCost2 = parseFloat(formCAMValues.cam_total_cost) || 0; 
          const camMarginMoney = camTotalCost2 - iRRTotalPrincipal; 
           // autoUpdateField("cam_margin_money", camMarginMoney.toFixed(2));
           // setCAMMarginMoney(camMarginMoney.toFixed(2));
      //  } 

        camCommercialsCalculations(); 

        if(formCAMValues.irr_total_value_of_combined_asset === ''){
          autoUpdateField("irr_total_value_of_combined_asset", totalValueCombine.toFixed(2));
        } 


        // Disbursement MEMO calculations : START HERE
        if(formCAMValues.dmemo_no_of_asset === ''){
          autoUpdateField("dmemo_no_of_asset", noOfAssetsToBeFinanced);
        }

        const assetsChassisCostClosedBody = formCAMValues?.assets_chassis_cost_closed_body || 0;
        const assetsChassisCostOpenBody = formCAMValues?.assets_chassis_cost_open_body || 0;
        const dmemoInvoicePricePerVehicleTotal = Number(assetsChassisCostClosedBody) + Number(assetsChassisCostOpenBody);

        autoUpdateField("dmemo_invoice_price_per_vehicle", dmemoInvoicePricePerVehicleTotal.toFixed(2));

        autoUpdateField("dmemo_insurance_by_cfpl", formCAMValues.assets_insurance_by_customer_ckers);
        autoUpdateField("dmemo_insurance_by_dealer", formCAMValues.assets_insurance_by_dealer);
 
        let dmemoInsuranceByCfpl = 0;
        let dmemoNoOfAsset = 0;
        let dmemoAssetCost = 0;
        let dmemoMarginMoneyVehicle = 0;
        let dmemoInvoicePricePerVehicle = 0;
        let dmemoFundingPerVehicle = 0;
        let dmemoPreEmi = 0;
        let dmemoPreEmiType = '';
        let dmemoKliAmount= 0;
        let dmemoKliAmountType = '';
        let dmemoFileChargeType = '';
        let dmemoProcessingFeeIncludingGstType = '';
        let dmemoFileCharge= 0;
        let dmemoProcessingFeeIncludingGst = 0;
        let camIarr = 0;
        let camFlatIrr = 0;
        let dmemoTenure = 0;
        let dmemoProcessingFeeOnFinanceAmountPlusGst = 0;
        let dmemoDealerSubvention = 0;

        

        if (formCAMValues?.dmemo_pre_emi_type === undefined) { 
          autoUpdateField("dmemo_pre_emi_type", "Upfront Collection");
        } 
        
        if (formCAMValues?.dmemo_kli_amount_type === undefined) {
           autoUpdateField("dmemo_kli_amount_type", "Upfront Collection");
        } 
        if (formCAMValues?.dmemo_file_charge_type === undefined) {
          autoUpdateField("dmemo_file_charge_type", "Upfront Collection");
       } 

       if (formCAMValues?.dmemo_processing_fee_including_gst_type === undefined) {
        autoUpdateField("dmemo_processing_fee_including_gst_type", "Upfront Collection");
     } 

        dmemoPreEmiType = formCAMValues.dmemo_pre_emi_type; 
        dmemoKliAmountType = formCAMValues.dmemo_kli_amount_type;
        dmemoFileChargeType = formCAMValues.dmemo_file_charge_type;
        dmemoProcessingFeeIncludingGstType = formCAMValues.dmemo_processing_fee_including_gst_type;
 
        if(formCAMValues.dmemo_dealer_subvention !==''){
          dmemoDealerSubvention = parseFloat(formCAMValues.dmemo_dealer_subvention) || 0;
        }

        if(formCAMValues.dmemo_invoice_price_per_vehicle !==''){
          dmemoAssetCost = parseFloat(formCAMValues.dmemo_invoice_price_per_vehicle) || 0;
        } 

        if(formCAMValues.dmemo_no_of_asset !==''){
          dmemoNoOfAsset = parseFloat(formCAMValues.dmemo_no_of_asset) || 0;
        }
        if(formCAMValues.dmemo_margin_money_vehicle !==''){
          dmemoMarginMoneyVehicle = parseFloat(formCAMValues.dmemo_margin_money_vehicle) || 0;
        }

        if(formCAMValues.dmemo_insurance_by_cfpl !==''){
          dmemoInsuranceByCfpl = parseFloat(formCAMValues.dmemo_insurance_by_cfpl) || 0;
        }

        if(formCAMValues.dmemo_invoice_price_per_vehicle !==''){
          dmemoInvoicePricePerVehicle = parseFloat(formCAMValues.dmemo_invoice_price_per_vehicle) || 0;
        }

        if(formCAMValues.dmemo_funding_per_vehicle !==''){
          dmemoFundingPerVehicle = parseFloat(formCAMValues.dmemo_funding_per_vehicle) || 0;
        }

        if(formCAMValues.dmemo_pre_emi !==''){
          dmemoPreEmi = parseFloat(formCAMValues.dmemo_pre_emi) || 0;
        }
  
        if(formCAMValues.dmemo_kli_amount !==''){
          dmemoKliAmount = parseFloat(formCAMValues.dmemo_kli_amount) || 0;
        } 

        if(formCAMValues.cam_file_charges !==''){
          dmemoFileCharge = parseFloat(formCAMValues.cam_file_charges) || 0;
        }

        if(formCAMValues.dmemo_processing_fee_including_gst !==''){
          dmemoProcessingFeeIncludingGst = parseFloat(formCAMValues.dmemo_processing_fee_including_gst) || 0;
        }

        if(formCAMValues.cam_iarr !==''){
          camIarr = parseFloat(formCAMValues.cam_iarr) || 0;
        }

        if(formCAMValues.cam_flat_irr !==''){
          camFlatIrr = parseFloat(formCAMValues.cam_flat_irr) || 0;
        }

        if(formCAMValues.dmemo_tenure !==''){
          dmemoTenure = formCAMValues.dmemo_tenure || 0;
        }

  
        if(formCAMValues.dmemo_processing_fee_on_finance_amount_plus_gst !==''){
          dmemoProcessingFeeOnFinanceAmountPlusGst = parseFloat(formCAMValues.dmemo_processing_fee_on_finance_amount_plus_gst) || 0;
        }

         
        const irrTotalAssetPrice = parseFloat(formCAMValues.irr_total_asset_price) || 0;

         
        const dmemoTotalCost =   dmemoAssetCost * dmemoNoOfAsset; 
        autoUpdateField("dmemo_invoice_price_all_vehicle", dmemoTotalCost.toFixed(2));
        
        const dmemoTotalCostPerVehicle = dmemoTotalCost + dmemoInsuranceByCfpl;
        // autoUpdateField("dmemo_total_cost_per_vehicle", dmemoTotalCostPerVehicle.toFixed(2));
        autoUpdateField("dmemo_total_cost_per_vehicle", irrTotalAssetPrice.toFixed(2));
        

        const dmemoTotalMarginMoneyVehicleCost =   dmemoMarginMoneyVehicle * dmemoNoOfAsset; 
        autoUpdateField("dmemo_margin_money_all_vehicle", dmemoTotalMarginMoneyVehicleCost.toFixed(2));


       
       // const dmemoFundingPerVehicle2 = dmemoAssetCost - dmemoMarginMoneyVehicle;
       const dmemoFundingPerVehicle2 = irrTotalAssetPrice - dmemoMarginMoneyVehicle;
        
        autoUpdateField("dmemo_funding_per_vehicle", dmemoFundingPerVehicle2.toFixed(2));
        //  
        // const dmemoLoanAmount = dmemoTotalCost - dmemoMarginMoneyVehicle;
        const dmemoLoanAmount = dmemoFundingPerVehicle2 * dmemoNoOfAsset;
        autoUpdateField("dmemo_loan_amount", dmemoLoanAmount.toFixed(2));

        let dmemoTotalLtv = 0;
        if( dmemoTotalCost > 0 ){
          dmemoTotalLtv = (dmemoLoanAmount / dmemoTotalCost ) * 100;
        }
       
       
       // autoUpdateField("dmemo_ltv", dmemoTotalLtv.toFixed(2));
       // autoUpdateField("dmemo_ltv", dmemoTotalLtv.toFixed(2));
        autoUpdateField("dmemo_irr", camIRRExcludingPF);
        autoUpdateField("dmemo_flat_rate", camFlatIrr);

        const  interestRate  = camIRRExcludingPF; 
        const  loanTerm  = dmemoTenure; 
        const  loanAmount  = dmemoLoanAmount.toFixed(2); 


        
        const dmemoEmiPerVehicle = calculatePMT(interestRate, loanTerm, dmemoFundingPerVehicle2,formCAMValues).toFixed(2);
        
        autoUpdateField("dmemo_emi_per_vehicle", dmemoEmiPerVehicle);

        const dmemoTotalEmiAllVehicle =   dmemoEmiPerVehicle * dmemoNoOfAsset; 
        autoUpdateField("dmemo_emi_all_vehicle", dmemoTotalEmiAllVehicle.toFixed(2));

        const dmemoProcessingFeeIncluding = calculateValue(dmemoLoanAmount, dmemoProcessingFeeOnFinanceAmountPlusGst);

       // if(formCAMValues.dmemo_processing_fee_including_gst === ''){
          autoUpdateField("dmemo_processing_fee_including_gst", dmemoProcessingFeeIncluding.toFixed(2));
      //  }
          autoUpdateField("dmemo_kli_amount", formCAMValues.cam_kotak_li_amount);
          autoUpdateField("dmemo_file_charge", formCAMValues.cam_file_charges);
        
        let dmemoTotalPreEmi = 0; 
        const startDate = formCAMValues.dmemo_pre_emi_start_date;
        const endDate = formCAMValues.dmemo_pre_emi_end_date;

        if( startDate !== '' && endDate !== '' ) {
          dmemoTotalPreEmi = calculateInterest(loanAmount, interestRate, startDate, endDate);
        }

       // if(formCAMValues.dmemo_pre_emi === ''){
          autoUpdateField("dmemo_pre_emi", dmemoTotalPreEmi.toFixed(2));
       // } 
 
        let dmemoTotalDisbursementAmountForVehicleIncludingBox = loanAmount - dmemoProcessingFeeIncluding - dmemoInsuranceByCfpl - dmemoDealerSubvention;

        if (formCAMValues?.dmemo_pre_emi_type === "Upfront Collection" || formCAMValues?.dmemo_pre_emi_type === undefined) {
          dmemoTotalDisbursementAmountForVehicleIncludingBox -= Number(formCAMValues?.dmemo_pre_emi) || 0;
        }

        if (formCAMValues?.dmemo_kli_amount_type === "Upfront Collection" || formCAMValues?.dmemo_kli_amount_type === undefined) {
          dmemoTotalDisbursementAmountForVehicleIncludingBox -= Number(formCAMValues?.dmemo_kli_amount) || 0;
        }else if (formCAMValues?.dmemo_kli_amount_type === "Funded with LA" ) {
          dmemoTotalDisbursementAmountForVehicleIncludingBox -= Number(formCAMValues?.dmemo_kli_amount) || 0;
        }

       // if (formCAMValues?.dmemo_file_charge_type === "Upfront Collection" || formCAMValues?.dmemo_file_charge_type === undefined) {
              dmemoTotalDisbursementAmountForVehicleIncludingBox -= Number(formCAMValues?.cam_file_charges) || 0;
       // }

         
        autoUpdateField("dmemo_disbursement_amount_for_vehicle_including_box", dmemoTotalDisbursementAmountForVehicleIncludingBox.toFixed(2)); 
 
        
        // =B16-B21+B30+IF(B28="Upfront Collection",B29,0)+B27+IF(B24="Upfront Collection",B25,0)
         /*
          B16 - Invoice Price - ( All Vehicles )
          B30 - File Charges
          B21 - Loan Amount
          B28 - KLI Type
          B29 - KLI Amount
          B27 - Processing Fee (Including GST)
          B24 - Pre-EMI Type
          B25 - Pre-Emi
        */ 
          
        let dmemoTotalDownPaymentByCustomer =
          (irrTotalAssetPrice * dmemoNoOfAsset) - dmemoLoanAmount ;

          if (formCAMValues?.dmemo_file_charge_type === "Upfront Collection" || formCAMValues?.dmemo_file_charge_type === undefined) {
            dmemoTotalDownPaymentByCustomer += Number(formCAMValues?.cam_file_charges) || 0;
          }

          if (formCAMValues?.dmemo_processing_fee_including_gst_type === "Upfront Collection" || formCAMValues?.dmemo_processing_fee_including_gst_type === undefined) {
            dmemoTotalDownPaymentByCustomer += Number(dmemoProcessingFeeIncluding) || 0;
          }
  

        if (formCAMValues?.dmemo_pre_emi_type === "Upfront Collection" || formCAMValues?.dmemo_pre_emi_type === undefined) {
          dmemoTotalDownPaymentByCustomer += Number(formCAMValues?.dmemo_pre_emi) || 0;
        }

       
        if (formCAMValues?.dmemo_kli_amount_type === "Upfront Collection" || formCAMValues?.dmemo_kli_amount_type === undefined) {
          dmemoTotalDownPaymentByCustomer += Number(formCAMValues?.dmemo_kli_amount) || 0;
        }
 
        const totalDownPayment  = dmemoTotalDownPaymentByCustomer;
        autoUpdateField("dmemo_total_down_payment_by_customer", totalDownPayment.toFixed(2));  
          
        // console.log(" camIarr = ", camIarr.toFixed(2));
        // Disbursement MEMO calculations : END HERE         
      }
  };
 
  const camFormCalculations = () => {
   
   // assets for calculations :  start here
    let sum = 0;
    let noOfVehiclesToBeFinance = 1;  
    let irrFinanceAmount = 0;
    let irrNoOfYears = 0;
    let irrNoOfEmi = 1;
    let irrFlatRate = 0;
    let camPF = 0;
    let camFinanceAmount = 0;
    Object.keys(formCAMValues).forEach((key) => {

      if (key === "irr_no_of_years") {
        irrNoOfYears = parseFloat(formCAMValues[key]?.replace(/\s/g, "")) || 0;
      } else if (key === "irr_no_of_emi") {
        irrNoOfEmi = parseFloat(formCAMValues[key]?.replace(/\s/g, "")) || 1; 
      } else if (key === "irr_finance_amount") {
        irrFinanceAmount = parseFloat(formCAMValues[key]?.replace(/\s/g, "")) || 0;
      } else if (key === "irr_flat_rate") {
        irrFlatRate = parseFloat(formCAMValues[key]?.replace(/\s/g, "")) || 0;  

      } else if (key === "assets_no_of_vehicles_to_be_finance") {
        noOfVehiclesToBeFinance = parseFloat(formCAMValues[key]?.replace(/\s/g, "")) || 1;
      } else if (key.startsWith("assets_")) {
        const value = parseFloat(formCAMValues[key]?.replace(/\s/g, "")) || 0;
       
        if (key === "assets_discount"){
          sum -= value;
        }else{
          sum += value;
        } 

      } else if (key === "cam_pf") {
        camPF = parseFloat(formCAMValues[key]?.replace(/\s/g, "")) || 0; 
      } else if (key === "cam_finance_value") {
        camFinanceAmount = parseFloat(formCAMValues[key]?.replace(/\s/g, "")) || 0; 
        
      }
    }); 

    

    const TotalAmountAsPerPerformInvoiceVal = sum * noOfVehiclesToBeFinance;
    setTotalAmountAsPerPerformInvoice(TotalAmountAsPerPerformInvoiceVal);
    setNoOfAssetsToBeFinanced(noOfVehiclesToBeFinance); 
     // assets for calculations :  end here

     // Fleet/Used Loan case: Total Principal, IRR, EMI, Interest, Repayment sab ab
     // "Finance Amount" (jo UI mein dikhta hai = Total Finance Amount) se calculate honge,
     // "Considering Loan Amount" (irr_finance_amount) se nahi. Normal case untouched.
     if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1) {
       irrFinanceAmount = parseFloat(formCAMValues.used_irr_total_finance_amount) || 0;
     }

     // formula = (Finance Amount / Total Value of Combined Asset) * 100
     const irrLTVPercentage = (irrFinanceAmount / TotalAmountAsPerPerformInvoiceVal) * 100;
     setIRRLTVPercentage(irrLTVPercentage);

     // formula  =  ((Finance Amount * Flat Rate * No. of years) + Finance Amount) / No. of EMI
     const irrEMIVal  = ((((irrFinanceAmount * irrFlatRate) /100 ) * irrNoOfYears ) + irrFinanceAmount ) / irrNoOfEmi;
     // console.log("irrEMIVal = ",irrEMIVal);

     const roundedIRRValue = Math.round(irrEMIVal);
     // console.log("roundedIRRValue = ",roundedIRRValue);

     setIRREMIValue(roundedIRRValue); 
     autoUpdateField("irr_emi_value", roundedIRRValue);

     // IRR calculation formula :  END HERE
      const financeAmount = irrFinanceAmount; // Loan amount
      const emiValue = roundedIRRValue;       // EMI value
      const numberOfEmis = irrNoOfEmi;      // Number of EMIs

      // Construct cash flows: Initial outflow followed by EMI inflows
      const cashFlows = [-financeAmount, ...Array(numberOfEmis).fill(emiValue)];

      // Calculate monthly IRR
      const monthlyIrr = calculateIRR(cashFlows); 
      let irrExcludingPFValue = 0;
      if (monthlyIrr !== null) {
        const annualizedIrr = monthlyIrr * 12 * 100; // Convert to percentage
        setAnnualIrr(annualizedIrr);

        irrExcludingPFValue = annualizedIrr > 0 ? annualizedIrr.toFixed(2) : annualizedIrr;
        setIrrExcludingPF(irrExcludingPFValue);
      } else {
        setAnnualIrr(0);
        setIrrExcludingPF(0);
      }
      // payload mein bhi wahi IRR (Excluding PF) jaye jo UI mein dikh raha hai
      autoUpdateField("irr_excluding_pf", irrExcludingPFValue);
      // IRR calculation formula :  END HERE

     // formula  =  (Finance Amount * Flat Rate * No. of years)  
     const irrTotalInterest  = ((irrFinanceAmount * irrFlatRate) /100 ) * irrNoOfYears 
     setIRRTotalInterest(irrTotalInterest);
     autoUpdateField("irr_total_interest", irrTotalInterest); 
 
     const roundedirrFinanceAmount = Math.round(irrFinanceAmount);
     setIRRTotalPrincipal(roundedirrFinanceAmount);
     // payload mein bhi wahi Total Principal jaye jo UI mein dikh raha hai (fleet case mein
     // irrFinanceAmount pehle hi upar used_irr_total_finance_amount se override ho chuka hai)
     autoUpdateField("irr_total_principal", roundedirrFinanceAmount);

     const totalRePay = irrFinanceAmount + irrTotalInterest;
     // const roundedTotalRePay = Math.round(irrFinanceAmount);
     const roundedTotalRePay = Math.round(totalRePay).toFixed(2);
     setIRRTotalRepayment(roundedTotalRePay); 
     autoUpdateField("irr_total_repayment", roundedTotalRePay); 

     // cam PF amount 
     const camPFAmount = (camPF * camFinanceAmount) /100;
     setCamTotalPFAmount(camPFAmount);
     autoUpdateField("cam_flat_irr", irrFlatRate);

     const camTotalCost2 = parseFloat(formCAMValues.cam_total_cost) || 0; 
     const camMarginMoney = camTotalCost2 - camFinanceAmount; 
    // console.log("1111111 camMarginMoney = ",camMarginMoney);
    // console.log("1111111111111111111111111111 - ",leadInfo);
     setCAMMarginMoney(camMarginMoney.toFixed(2));


     // IRR calculation formula :  END HERE
     const financeAmountCam = camFinanceAmount; // Loan amount
     
     const emiValueCam = roundedIRRValue;       // EMI value
     const numberOfEmisCam = irrNoOfEmi;      // Number of EMIs

     // Construct cash flows: Initial outflow followed by EMI inflows
     // const cashFlowsCam = [-financeAmountCam, ...Array(numberOfEmisCam).fill(emiValueCam)];

     const cashFlowsCam = [-irrFinanceAmount, ...Array(numberOfEmisCam).fill(emiValueCam)];

     // Calculate monthly IRR
     const monthlyIrrCam = calculateIRR(cashFlowsCam); 
     if (monthlyIrrCam !== null) {
       const annualizedIrr = monthlyIrrCam * 12 * 100; // Convert to percentage 
       setCamIRRExcludingPF(annualizedIrr > 0 ? annualizedIrr.toFixed(2) : annualizedIrr);
     } else {
        setCamIRRExcludingPF(0);
     }
     autoUpdateField("cam_iarr", camIRRExcludingPF); // nsp
     autoUpdateField("irr_ltv_percentage", iRRLTVPercentage.toFixed(2));  // nsp
     // IRR calculation formula :  END HERE 

     
     setDefaultFieldsValues();

     
   
  };


  const handleInputChange = (id, field, value) => {
    setCoapplicantGuarantorRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  useEffect(() => { 
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    } 
     
   // if(coapplicantGuarantorRows.length < 1){
    setAddedLeadCoapplicantGuarantorRows([]); 
      if (props.leadInfo && props.leadInfo.data && Array.isArray(props.leadInfo.data) && props.leadInfo.data.length > 0) { 
        const allCoApplicants = props.leadInfo.data[0].lead_co_applicants;
        const allguarantors = props.leadInfo.data[0].lead_guarantors; 
       if(allCoApplicants.length > 0) {
          // Push co-applicant details into  array
          const coApplicants = allCoApplicants.map((coApplicant, index) => ({
            id: `C${coApplicant.id}`,  
            type:  "Co-Applicant",
            name: `${coApplicant.first_name || ""} ${coApplicant.last_name || ""}`.trim(),
            pan_number: coApplicant.pan_number?.replace(/"/g, "") || "",
            father_name : '',
            adhar_number: coApplicant.adhar_number?.replace(/"/g, "") || "",
            dob : coApplicant.dob || "",
            relation : coApplicant.relationName || "",
            full_address : coApplicant.full_address || "",
            permanent_address : coApplicant.full_address || "",
            office_address : "",
            mobile : coApplicant.mobile || "",
            reference_details:"",
            crif_score: coApplicant.crif_info.crif_score || "",
            bureau_remarks:"",
            status : coApplicant.status || "",
          }));
          setAddedLeadCoapplicantGuarantorRows((prevRows) => [...prevRows, ...coApplicants]);
      }

      if(allguarantors.length > 0) {
        // Push co-applicant details into  array
        const guarantors = allguarantors.map((gur, index) => ({
          id: `G${gur.id}`,  
          type:  "Guarantors",
          name: `${gur.first_name || ""} ${gur.last_name || ""}`.trim(),
          pan_number: gur.pan_number?.replace(/"/g, "") || "",
          father_name : '',
          adhar_number: gur.adhar_number?.replace(/"/g, "") || "",
          dob : gur.dob || "", 
          relation : gur.relationName || "",
          full_address : gur.full_address || "",
          permanent_address : gur.full_address || "",
          office_address: "",
          mobile : gur.mobile || "",
          reference_details:"",
          crif_score: gur.crif_info.crif_score || "",
          bureau_remarks:"",
          status : gur.status || "",
        }));
        setAddedLeadCoapplicantGuarantorRows((prevRows) => [...prevRows, ...guarantors]);
      } 
    }
     // }
    }, [leadInfo]);

  // Used Loan IRR: Calculate Considering Loan Amount (Row 10)
  // Formula: Considering Loan Amount = Deal Value - DP/Margin
  useEffect(() => {
    // Only run for Used Loans
    if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) !== 1) return;

    const dealValue = parseFloat(formCAMValues.irr_total_asset_price || 0);
    const dpMargin = parseFloat(formCAMValues.used_irr_dp_margin || 0);
    const consideringLoanAmount = dealValue - dpMargin;

    setFormCAMValues(prev => ({
      ...prev,
      irr_finance_amount: consideringLoanAmount.toFixed(2)
    }));
  }, [formCAMValues.irr_total_asset_price, formCAMValues.used_irr_dp_margin, leadInfo]);

  // Used Loan IRR: Calculate Total Finance Amount (Row 12)
  // Ab Finance Amount + CLI + PF Fund in LA + Documents Charges - sabko jodkar banega
  useEffect(() => {
    // Only run for Used Loans
    if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) !== 1) return;

    const financeAmount = parseFloat(formCAMValues.irr_finance_amount || 0);
    const cliAmount = parseFloat(formCAMValues.cam_kotak_li_amount || 0);
    const pfFundInLA = parseFloat(formCAMValues.used_irr_pf_fund_in_la || 0);
    const docCharges = parseFloat(formCAMValues.cam_file_charges || 0);
    const totalFinanceAmount = financeAmount + cliAmount + pfFundInLA + docCharges;

    setFormCAMValues(prev => ({
      ...prev,
      used_irr_total_finance_amount: totalFinanceAmount.toFixed(2)
    }));
  }, [formCAMValues.irr_finance_amount, formCAMValues.cam_kotak_li_amount, formCAMValues.used_irr_pf_fund_in_la, formCAMValues.cam_file_charges, leadInfo]);

  // Used Loan IRR: Calculate Revised Loan Amount (Row 15)
  // NOTE: "Total Finance Amount" (Row 12) ab khud PF Fund in LA + Doc Charges include karta hai,
  // isliye yahan dobara add nahi karna - warna values double ho jayengi.
  // Revised Loan Amount ab seedha Total Finance Amount ke barabar hai.
  useEffect(() => {
    // Only run for Used Loans
    if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) !== 1) return;

    const totalFinanceAmount = parseFloat(formCAMValues.used_irr_total_finance_amount || 0);

    setFormCAMValues(prev => ({
      ...prev,
      used_irr_revised_loan_amount: totalFinanceAmount.toFixed(2)
    }));
  }, [formCAMValues.used_irr_total_finance_amount, leadInfo]);

  // Used Loan IRR: Calculate PF 2% of Total Finance Amount (Including GST) - Fund in LA (Row 13)
  // Formula: ROUNDUP((base*2%)+(base*2%*18%),0)  where base = Considering Loan Amount + CLI Amount
  // NOTE: PF ab "Total Finance Amount" (Row 12) se calculate NAHI hota - kyunki Row 12 khud isi
  // PF value ko include karta hai. Agar wahan se base liya to circular dependency ban jaati hai
  // aur PF galat/inflated aata hai. Isliye seedha Considering Loan Amount + CLI se nikal rahe hain.
  useEffect(() => {
    // Only run for Used Loans
    if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) !== 1) return;

    const financeAmount = parseFloat(formCAMValues.irr_finance_amount || 0);
    const cliAmount = parseFloat(formCAMValues.cam_kotak_li_amount || 0);
    const baseAmount = financeAmount + cliAmount;
    const pfFundInLA = Math.ceil((baseAmount * 0.02) + (baseAmount * 0.02 * 0.18));

    setFormCAMValues(prev => ({
      ...prev,
      used_irr_pf_fund_in_la: pfFundInLA.toFixed(2)
    }));
  }, [formCAMValues.irr_finance_amount, formCAMValues.cam_kotak_li_amount, leadInfo]);

    // Used Loan IRR: Calculate Adjust PF% as per old Loan Amount (Row 16)
  // Requirement: iska value hamesha "PF 2% of Total Finance Amount (Including GST) - Fund in LA"
  // (used_irr_pf_fund_in_la) ke barabar hona chahiye - isliye seedha wahi value mirror kar rahe hain.
  useEffect(() => {
    // Only run for Used Loans
    if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) !== 1) return;

    const pfFundInLA = parseFloat(formCAMValues.used_irr_pf_fund_in_la || 0);

    setFormCAMValues(prev => ({
      ...prev,
      used_irr_adjust_pf_old_loan: pfFundInLA.toFixed(2)
    }));
  }, [formCAMValues.used_irr_pf_fund_in_la, leadInfo]);

  // Used Loan IRR: Calculate PF Amount, GST, and Total PF (Rows 18, 19, 20)
  useEffect(() => {
    // Only run for Used Loans
    if (parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) !== 1) return;


    // NOTE: PF% ka base ab "Finance Amount" (irr_finance_amount) hai, "Total Finance Amount" nahi -
    // sheet ke hisaab se (270000 * 2% = 5400, GST 972, Total 6372)
    const irrFinanceAmountForPf = parseFloat(formCAMValues.irr_finance_amount || 0);
    const pfPercentage = parseFloat(formCAMValues.used_irr_pf_percentage || 0);

    // Row 18: PF in Amount
    const pfAmount = irrFinanceAmountForPf * pfPercentage / 100;

    console.log("------1111 irr Finance Amount:", irrFinanceAmountForPf);
    console.log("------2222 PF Percentage:", pfPercentage);
    console.log("------3333 Calculated PF Amount:", pfAmount);

    // Row 19: GST (18%)
    const gstAmount = pfAmount * 0.18;

    // Row 20: Total PF Amount
    const totalPfAmount = pfAmount + gstAmount;

    setFormCAMValues(prev => ({
      ...prev,
      used_irr_pf_amount: pfAmount.toFixed(2),
      used_irr_gst_amount: gstAmount.toFixed(2),
      used_irr_total_pf_amount: totalPfAmount.toFixed(2)
    }));
  }, [formCAMValues.irr_finance_amount, formCAMValues.used_irr_pf_percentage, leadInfo]);



   /* const pushAddedNewCoApplicantGuarantor = () => {
      setCoapplicantGuarantorRows((prevVar) => {
         const newItems = addedLeadCoapplicantGuarantorRows.filter(
          (item) => !prevVar.some((existingItem) => existingItem.id === item.id)
        );
         return [...prevVar, ...newItems];
      });
    }; */

    
    const pushAddedNewCoApplicantGuarantor = () => {
      setCoapplicantGuarantorRows((prevVar) => {
        // Update only the `status` field of matching rows
        const updatedRows = prevVar.map((existingItem) => {
          const match = addedLeadCoapplicantGuarantorRows.find(
            (item) => item.id === existingItem.id
          );
          return match
            ? { ...existingItem, status: match.status } // only update status
            : existingItem;
        });

        // Add only new rows
        const newItems = addedLeadCoapplicantGuarantorRows.filter(
          (item) => !prevVar.some((existingItem) => existingItem.id === item.id)
        );

        return [...updatedRows, ...newItems];
      });
    };

/*
    const pushAddedNewCoApplicantGuarantor = () => {
    setCoapplicantGuarantorRows((prevVar) => {
      // create a map of existing rows
      const updatedRows = prevVar.map((existingItem) => {
        const match = addedLeadCoapplicantGuarantorRows.find(
          (item) => item.id === existingItem.id
        );
        return match ? { ...existingItem, ...match } : existingItem;
      });

      // add only new rows that don't exist already
      const newItems = addedLeadCoapplicantGuarantorRows.filter(
        (item) => !prevVar.some((existingItem) => existingItem.id === item.id)
      );

      return [...updatedRows, ...newItems];
    });
  }; */

const checkIsUsedLoanStatus = async () => {
  if (!id) return;

  try {
    const decodedId = atob(id);

    const payload = {
      lead_id: decodedId,
    };

    const res = await fetch(
      `${config.API_BASE_URL}getIsUsedLoanStatus`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: encryptData(payload),
      }
    );

    const result = await res.json();

    if (result?.data?.success === 1) {
      setIsUsedVehicle(!!result.data.data?.is_used_loan);
    } else {
      setIsUsedVehicle(false);
    }
  } catch (error) {
    console.error("Error checking used loan status:", error);
    setIsUsedVehicle(false);
  }
};

const fetchUsedVehicleDealValue = async () => {
  if (!id) return;

  try {
    const decodedId = atob(id);

    const payload = {
      lead_id: decodedId,
    };

    const res = await fetch(
      `${config.API_BASE_URL}getUsedVehicleDealValue`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: encryptData(payload),
      }
    );

    const result = await res.json();

    if (result?.data?.success === 1) {
      const chassisCostDealClose = result.data.data?.assets_chassis_cost_closed_body || "0.00";
      autoUpdateField("used_irr_chassis_cost_deal_close", chassisCostDealClose);
    }
  } catch (error) {
    console.error("Error fetching used vehicle deal value:", error);
  }
};

// useEffect(() => {
//   if (isActive && isUsedVehicle) {
//     fetchUsedVehicleDealValue();
//   }
// }, [isActive, isUsedVehicle, id]);
  
  const getCAMDetailsData = async () => {
    if (!id) {
      console.error("Error: ID is undefined.");
      return;
    }
  
    try {
      const decodedId = atob(id);
      const obj = {
        start: '0',
        length: config.MAX_RECORDS,
        lead_id: decodedId,
        with_additional_info:'yes',
        version_id : selectionVersioningID
      };
   
      setCoapplicantGuarantorRows(addedLeadCoapplicantGuarantorRows);
      const requestData = encryptData(obj);
      const result = await actions.getCAMDetails(requestData);
  
      if (result?.data?.success === 1) {
        const results = result.data.data?.data || {};
        const resultArr = Object.values(results);
        
        if (resultArr?.length > 0 && resultArr[0]?.cam_details) {
            const camDetails = resultArr[0].cam_details; 
            const jsonData = JSON.parse(camDetails);  
            
            if (jsonData?.dob === '0000-00-00') {
              jsonData.dob = '';
            }

            // Assets Details ki fresh loaded values ko seedha jsonData par patch karo
            // (state se nahi lena hai, kyuki niche camFormCalculations() abhi bhi PURANE
            // formCAMValues closure ko use karega — setFormCAMValues async hai)
            // Note: leadInfo abhi tak load nahi hua hota is point tak, isliye is_used_loan
            // check yahan bharosemand nahi — hamesha patch karo, harmless hai non-used-loan ke liye
            jsonData.used_irr_chassis_cost_deal_close = jsonData.assets_chassis_cost_closed_body || '0.00';
            jsonData.used_irr_insurance_by_customer_ckers = jsonData.assets_insurance_by_customer_ckers || '0.00';

            setFormCAMValues(jsonData);  
            if (jsonData?.coapplicantGuarantorDetails) {
             setCoapplicantGuarantorRows(jsonData.coapplicantGuarantorDetails);
             // setAddedLeadCoapplicantGuarantorRows
             pushAddedNewCoApplicantGuarantor();
            }      
            camFormCalculations();

            // Corrective fix: camFormCalculations() abhi upar PURANE (pre-load) formCAMValues
            // closure se "Total Amount As Per Perform Invoice" calculate karta hai, isliye
            // "Deal Value - Net cost to customer" (irr_total_asset_price) ko galti se "0.00"
            // kar deta hai. Yahan jsonData se seedha sahi total nikalke dobara set kar rahe
            // hain — ye AAKHRI mein chalta hai isliye jeetega.
            let correctedTotal = 0;
            let correctedNoOfVehicles = 1;
            Object.keys(jsonData).forEach((key) => {
              if (key === 'assets_no_of_vehicles_to_be_finance') {
                correctedNoOfVehicles = parseFloat(String(jsonData[key]).replace(/\s/g, "")) || 1;
              } else if (key.startsWith('assets_')) {
                const val = parseFloat(String(jsonData[key]).replace(/\s/g, "")) || 0;
                if (key === 'assets_discount') {
                  correctedTotal -= val;
                } else {
                  correctedTotal += val;
                }
              }
            });
            correctedTotal *= correctedNoOfVehicles;
            setTotalAmountAsPerPerformInvoice(correctedTotal);
            autoUpdateField("irr_total_asset_price", correctedTotal.toFixed(2));

            setIsReadyToModify(resultArr[0]?._isReadyToModify);  
        }

         const rsmRhChLatestHistoryInfo = resultArr[0]?.additional_info?.rsm_rh_ch_latest_history || [];

         if(rsmRhChLatestHistoryInfo.length > 0){
            const formInfo =   rsmRhChLatestHistoryInfo?.[0] || [];
            setRsmRhChLatestHistoryData(formInfo);
             setFormCAMRSMRHCHValues( {
              rsm_rh_ch_review: formInfo?.review,
              rsm_rh_ch_remarks: formInfo?.remarks,    
            });
         }          

        const crifDetailsMaster = resultArr[0]?.additional_info?.crif_details || [];
        setCrifDetails(crifDetailsMaster);

        const bankDetailsMaster = resultArr[0]?.additional_info?.banking_details || [];
        setBankDetails(bankDetailsMaster);

        const dedupeMatchesArr = resultArr[0]?.additional_info?.dedupe_matches || [];
        setDedupeMatchesDetails(dedupeMatchesArr);

        const camApprovalHistoryInfo = resultArr[0]?.additional_info?.cam_approval_history || [];
        setCamApprovalHistory(camApprovalHistoryInfo);
 
        if (camApprovalHistoryInfo.length > 0 && camApprovalHistoryInfo[0]?.created_at) {
           setCamApproveLatestStatus(camApprovalHistoryInfo[0]?.action_status);
           if(camApprovalHistoryInfo[0]?.action_status < 1){
            const showResNote = `Sent to Credit Head On ${camApprovalHistoryInfo[0].created_at}`;
            setShowCamNote(showResNote);
          }
 
          if (camApprovalHistoryInfo[0]?.action_status === '1') {
            const showResNote = `CAM Approved By Credit Head On ${camApprovalHistoryInfo[0]?.created_at}`;
            setShowCamNote(showResNote);
        }

          if(camApprovalHistoryInfo[0]?.action_status === '2'){
            const showResNote = `CAM Rejected By Credit Head On ${camApprovalHistoryInfo[0].created_at},  Comment : ${camApprovalHistoryInfo[0].notes}`;
            setShowCamNote(showResNote);
          }

          if(camApprovalHistoryInfo[0]?.action_status === '3'){
            const showResNote = `CAM Reversal Request By Credit On ${camApprovalHistoryInfo[0].created_at},  Comment : ${camApprovalHistoryInfo[0].notes}`;
            setShowCamNote(showResNote);
          }
        }


         const runCustomerDedupeHistoryInfo = resultArr[0]?.additional_info?.run_customer_dedupe_history || [];
        setRunCustomerDedupeHistory(runCustomerDedupeHistoryInfo);

        const camCustomerDedupeHistoryInfo = resultArr[0]?.additional_info?.cam_customer_dedupe_history || [];
        setCamCustomerDedupeHistory(camCustomerDedupeHistoryInfo);
 
        if (camCustomerDedupeHistoryInfo.length > 0 && camCustomerDedupeHistoryInfo[0]?.created_at) {
           setCamCustomerDedupeLatestStatus(camCustomerDedupeHistoryInfo[0]?.action_status);
           if(camCustomerDedupeHistoryInfo[0]?.action_status < 1){
          //  const showResNote = `Sent to Credit Head On ${camCustomerDedupeHistoryInfo[0].created_at}`;
           // setShowCamCustomerDedupeNote(showResNote);
          }
 
          if (camCustomerDedupeHistoryInfo[0]?.action_status === '1') {
            const showResNote = `Customer Dedupe Approved By ${camCustomerDedupeHistoryInfo[0]?.createdByName} On ${camCustomerDedupeHistoryInfo[0]?.created_at}`;
            setShowCamCustomerDedupeNote(showResNote);
        }

          if(camCustomerDedupeHistoryInfo[0]?.action_status === '2'){
            const showResNote = `Customer Dedupe Rejected By ${camCustomerDedupeHistoryInfo[0]?.createdByName} On ${camCustomerDedupeHistoryInfo[0].created_at},  Comment : ${camCustomerDedupeHistoryInfo[0].notes}`;
            setShowCamCustomerDedupeNote(showResNote);
          }

          if(camCustomerDedupeHistoryInfo[0]?.action_status === '3'){
            const showResNote = `Customer Dedupe Reversal Request By ${camCustomerDedupeHistoryInfo[0]?.createdByName} On ${camCustomerDedupeHistoryInfo[0].created_at},  Comment : ${camCustomerDedupeHistoryInfo[0].notes}`;
            setShowCamCustomerDedupeNote(showResNote);
          }
        }
 

        const anchorCategoryMaster = resultArr[0]?.additional_info?.anchor_category_master || [];
        setAnchorCategories(anchorCategoryMaster);

        const speciallyAbledMaster = resultArr[0]?.additional_info?.specially_abled || [];
        setSpeciallyAbledArr(speciallyAbledMaster);

        const residenceTypesMaster = resultArr[0]?.additional_info?.residence_types || [];
        setResidenceTypesArr(residenceTypesMaster);

        const bankingUpiMaster = resultArr[0]?.additional_info?.banking_upis || [];
        setBankingUpiArr(bankingUpiMaster);
        
        const drivingLicenseTypeMaster = resultArr[0]?.additional_info?.driving_license_type_master || [];
        setDrivingLicenseTypeMasterArr(drivingLicenseTypeMaster);

        const constitutionMaster = resultArr[0]?.additional_info?.constitutions || [];
        setConstitutionArr(constitutionMaster);

        const customerTypeMaster = resultArr[0]?.additional_info?.customer_type || [];
        setCustomerTypeArr(customerTypeMaster);

        const vehicleMakerMaster = resultArr[0]?.additional_info?.vehicle_maker || [];
        setVehicleMakerArr(vehicleMakerMaster);

        const vehicleUseMaster = resultArr[0]?.additional_info?.vehicle_use || [];
        setVehicleUseArr(vehicleUseMaster);

        const insuranceMaster = resultArr[0]?.additional_info?.insurance || [];
        setInsuranceArr(insuranceMaster);

        const vehicleModelsMaster = resultArr[0]?.additional_info?.vehicle_models || [];
        setVehicleModelsArr(vehicleModelsMaster);

        const businessValidationProofMaster = resultArr[0]?.additional_info?.business_validation_proof || [];
        setBusinessValidationProofArr(businessValidationProofMaster);

        const turnoverIncomeMaster = resultArr[0]?.additional_info?.turnover_income || [];
        setTurnoverIncomeArr(turnoverIncomeMaster);

        const workingCapitalCycleMaster = resultArr[0]?.additional_info?.working_capital_cycle || [];
        setWorkingCapitalCycleArr(workingCapitalCycleMaster);

        const accountTypeMaster = resultArr[0]?.additional_info?.account_type_master || [];
        setAccountTypeArr(accountTypeMaster);

        const allDealersMaster = resultArr[0]?.additional_info?.all_dealers || [];
        setAllDealersArr(allDealersMaster);
 
         
      } 
    } catch (error) {
     // console.error("Error in getCAMDetailsData:", error);
    }
  };

    useEffect(() => { 
    if (isActive) {
     getCAMDetailsData();
    }
  }, [isActive, id, selectionVersioningID]);

  const onSubmit = async (data) => {
   // alert(formCAMValues.remarks_account_holder_name);
    if(isReadyToModify){ 
       if((formCAMValues.cam_driving_license_type === 'LMV') && formCAMValues.cam_dl === ''){
           // Catch and log errors
          toast.error("Driving License Number is required.", {
            position: "top-right",
          });

       }else if(formCAMValues.remarks_bank_name === ''){  
          toast.error("CAM : Bank Name is required.", {
            position: "top-right",
          });

        }else if(formCAMValues.remarks_account_holder_name === '' || formCAMValues.remarks_account_holder_name === undefined){   
          toast.error("CAM : Account Holder Name is required.", {
            position: "top-right",
          }); 
        }else if(formCAMValues.remarks_account_no === '' || formCAMValues.remarks_ifsc_code === undefined){   
          toast.error("CAM : A/c No is required.", {
            position: "top-right",
          });     
          
        }else if(formCAMValues.remarks_ifsc_code === '' || formCAMValues.remarks_ifsc_code === undefined){   
          toast.error("CAM : IFSC Code is required.", {
            position: "top-right",
          }); 
          
        }else if(formCAMValues.remarks_type_of_account === '' || formCAMValues.remarks_type_of_account === undefined){   
          toast.error("CAM : Type of Account is required.", {
            position: "top-right",
          });       
       }else{
     
        setNoOfAssetsToBeFinancedAfter(data.irr_no_of_assets_to_be_financed);
        // setTotalValueCombine(data.irr_total_value_of_combined_asset);

        
        if(camLatestStatus ==='1' && !props.enableCamDetailsStatus){
              toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
                    position: "top-right",
                });
                return;
          }
        try { 

          formCAMValues.coapplicantGuarantorDetails = coapplicantGuarantorRows
        // console.log(" FormCAMValues = " ,formCAMValues); 
          const params = { lead_id: atob(id), formData: formCAMValues,"camLatestStatus":camLatestStatus, "enableCamDetailsHandler" : enableCamDetailsHandler };
          const requestData = encryptData(params);
          // Await the response from manageCAMDetails
          const result = await actions.manageCAMDetails(requestData);
          // Handle success and error scenarios
          if (result.data.success === 1) {
            toast.success(result.data.message, {
              position: "top-right",
            });

            // Call to fetch updated data
            getCAMDetailsData();
    
            vivritiChecklistStatusHandler(result.data?.vivriti_checklist_status);
            fetchLeads();
            // open the sanction tab 
            if(props.enableCamDetailsStatus){
              backToLeadHandler('sanction_letter');
              enableCamDetailsHandler(false);  
            } 
          } else {
            toast.error(result.data.message, {
              position: "top-right",
            });
          }
        } catch (error) {
          // Catch and log errors
          console.error("Error in onSubmit:", error);
          toast.error("An error occurred. Please try again.", {
            position: "top-right",
          });
        }
      }
    }else{
      // Catch and log errors
       toast.error("You can't update the saved data. To update the CAM details, please select the blank option from the Versioning dropdown.", {
        position: "top-right",
      });
    }
  };

  function handleForApprovalCredit(action,notes='') {
    let actionStatus = '0';
    let submitStatus =  true;
    if(action ==='approve'){
      actionStatus = '1';
      if(notes ===''){
          toast.error("Notes is required.", {
              position: "top-right",
          });
          submitStatus =  false;
      }
    }else if(action ==='reject'){
      actionStatus = '2';

      if(notes ===''){
          toast.error("Notes is required.", {
              position: "top-right",
          });
          submitStatus =  false;
      }
    }else if(action ==='reversal'){
      actionStatus = '3';

      if(notes ===''){
          toast.error("Notes is required.", {
              position: "top-right",
          });
          submitStatus =  false;
      }

    }else if(action ==='request'){
     // console.log( "allLeadBankStatementCount = ", allLeadBankStatementCount);
     // alert('here');
     /* if (leadInfo?.data?.length > 0) {
        const noBankStatement = leadInfo.data[0]?.no_bank_statement;
         if(noBankStatement !== '1' && allLeadBankStatementCount < 1){
              toast.error("Bank Statements are not uploaded.", {
                  position: "top-right",
              });
              submitStatus =  false;
            } 
          
      } */

      const fiChecklistCompletedStatus =  leadInfo?.data?.[0]?.fiChecklistCompletedStatus;
     // console.log("leadInfo = ", leadInfo); 
      if( !fiChecklistCompletedStatus ){
        toast.error("FI checklists are not completed.", {
            position: "top-right",
        });
        submitStatus =  false;
      } 
      // fiChecklistCompletedStatus 
    }

    

    if(submitStatus){
    const params = { 'lead_id': atob(id),"action_status":actionStatus,'notes' :notes , 'userRoleType' : userRoleType };
    // console.log("handleForApprovalCredit = ", params);
    const requestData = encryptData(params);
     const response = actions.addCamApprovalAction(requestData);
    response.then((result) => { 
        // console.log("Promise resolved - add/edit lead form:", result);
        setOpenRejectAmt(false);
         setOpenDedupe(false);
        setApproveBtnAction(0);
        if (result.data.success === 1) {
            toast.success(result.data.message, {
                position: "top-right",
            });
            const addCreditInfo = result.data.data;
            if (addCreditInfo !== "") {
                if (Object.prototype.hasOwnProperty.call(addCreditInfo, 'created_date')) {
                    const showResNote = `Sent to Credit Head On ${addCreditInfo.created_date} `;
                    setShowCamNote(showResNote);
                }
                getCAMDetailsData();
            }
        } else {
            toast.error(result.data.message, {
                position: "top-right",
            });
        }
    }).catch((error) => {
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
            position: "top-right",
        });
    });
  }

}


const [formRejectitem, setFormRejectitem] = useState({
  notes: '',
});

const [formDedupeitem, setFormDedupeitem] = useState({
  notes: '',
});

const btnOpenRejectData = (approveBtnAction) => {    // buttonFun

  setApproveBtnAction(approveBtnAction);
  setOpenRejectAmt(true);
  };

const handleCloseRejectAmt = () => {     // Modal onclick closedFun
  setApproveBtnAction(0);
  setOpenRejectAmt(false);
 };

 

 const handleRejectFormSubmit = (data) => {
  if (data.notes === '') {
    toast.error("Notes is required.", {
      position: "top-right",
    });
  } else { 
    
      if(approveBtnAction === '1'){
        handleForApprovalCredit('approve',data.notes);
      }
      
      if(approveBtnAction === '2'){
        handleForApprovalCredit('reject',data.notes);
      }

      if(approveBtnAction === '3'){
        handleForApprovalCredit('reversal',data.notes);
      }
  }
 }

 const handleAmtRejectChange = (e) => {
  const totalAmt = e.target.value;
  setFormRejectitem((prevState) => ({
    ...prevState,
    totalAmt,
  }));
}


 function handleForApprovalDedupe(action,notes='') {
    let actionStatus = '0';
    let submitStatus =  true;
    if(action ==='approve'){
      actionStatus = '1';
      if(notes ===''){
          toast.error("Notes is required.", {
              position: "top-right",
          });
          submitStatus =  false;
      }
    }else if(action ==='reject'){
      actionStatus = '2';

      if(notes ===''){
          toast.error("Notes is required.", {
              position: "top-right",
          });
          submitStatus =  false;
      }
    }else if(action ==='reversal'){
      actionStatus = '3';

      if(notes ===''){
          toast.error("Notes is required.", {
              position: "top-right",
          });
          submitStatus =  false;
      }

    }else if(action ==='request'){
     // console.log( "allLeadBankStatementCount = ", allLeadBankStatementCount);
     // alert('here');
     /* if (leadInfo?.data?.length > 0) {
        const noBankStatement = leadInfo.data[0]?.no_bank_statement;
         if(noBankStatement !== '1' && allLeadBankStatementCount < 1){
              toast.error("Bank Statements are not uploaded.", {
                  position: "top-right",
              });
              submitStatus =  false;
            } 
          
      } */

           
      const fiChecklistCompletedStatus =  leadInfo?.data?.[0]?.fiChecklistCompletedStatus;
     // console.log("leadInfo = ", leadInfo); 
    /*  if( !fiChecklistCompletedStatus ){
        toast.error("FI checklists are not completed.", {
            position: "top-right",
        });
        submitStatus =  false;
      } */
      // fiChecklistCompletedStatus 

    }else if(action ==='run_dedupe'){
      actionStatus = '4';
    }   

    

    if(submitStatus){
    const params = { 'lead_id': atob(id),"action_status":actionStatus,'notes' :notes , 'userRoleType' : userRoleType };
    // console.log("handleForApprovalCredit = ", params);
    const requestData = encryptData(params);
     const response = actions.addCamCustomerDedupeAction(requestData);
    response.then((result) => { 
        // console.log("Promise resolved - add/edit lead form:", result);
        setOpenRejectAmt(false);
         setOpenDedupe(false);
        setApproveBtnDedupeAction(0);
        if (result.data.success === 1) {
            toast.success(result.data.message, {
                position: "top-right",
            });
            const addCreditInfo = result.data.data;
            if (addCreditInfo !== "") {
               /* if (Object.prototype.hasOwnProperty.call(addCreditInfo, 'created_date')) {
                    const showResNote = `Sent to Credit Head On ${addCreditInfo.created_date} `;
                    setShowCamCustomerDedupeNote(showResNote);
                } */
                getCAMDetailsData();
            }
        } else {
            toast.error(result.data.message, {
                position: "top-right",
            });
        }
    }).catch((error) => {
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
            position: "top-right",
        });
    });
  }

}

const btnOpenDedupeData = (approveBtnAction) => {    // buttonFun

  
  setApproveBtnDedupeAction(approveBtnAction);
  if(approveBtnAction === '4'){
      setOpenDedupe(false);
      handleForApprovalDedupe('run_dedupe','');
  }else{
    setOpenDedupe(true);
  }
  };

const handleAmtDedupeChange = (e) => {
  const totalAmt = e.target.value;
  setFormDedupeitem((prevState) => ({
    ...prevState,
    totalAmt,
  }));
}

const handleCloseDedupe = () => {     // Modal onclick closedFun
  setApproveBtnDedupeAction(0);
  setOpenDedupe(false);
 };

 const handleDedupeFormSubmit = (data) => {

  if(approveBtnDedupeAction === '4'){
     handleForApprovalDedupe('run_dedupe','');
  }else if (data.notes === '') {
    toast.error("Notes is required.", {
      position: "top-right",
    });
  } else { 
    
      if(approveBtnDedupeAction === '1'){
        handleForApprovalDedupe('approve',data.notes);
      }
      
      if(approveBtnDedupeAction === '2'){
        handleForApprovalDedupe('reject',data.notes);
      }

      if(approveBtnDedupeAction === '3'){
        handleForApprovalDedupe('reversal',data.notes);
      }
  }
 }

 
/*
// COMMENTED OUT: This useEffect was causing infinite re-renders and making fields unresponsive
// The calculations should be triggered manually when needed, not on every formCAMValues change
useEffect(() => {
  camFormCalculations(); // Recalculate when formCAMValues change
}, [formCAMValues]);
*/
/*
useEffect(() => {
  if (isActive) {
    camFormCalculations();
  }
}, [isActive,formCAMValues]); */

  const [showEditIRRSheet, setShowEditIRRSheet] = useState(true);
  const [showEditAssetSheet, SetshowEditAssetSheet] = useState(true);

  const handleToggle = () =>{
    setShowEditIRRSheet(prevState => !prevState); 
    SetshowEditAssetSheet(prevState => !prevState); 
  }

const leadProfiless = props?.leadInfo?.data?.[0]?.lead_profile;
const showViability = leadProfiless === "11";

const leadpostdata = props?.leadInfo?.data?.[0];

  return (
    <>
      <div id="main-wrap" className='mt-4 cam_section'>
        <div className='row justify-content-between'>
          <div className="row">
            <div className='col-md-12'>
              <h5>CAM</h5>


               {userRoleType === 'Credit' ? (
                  showCamNote !== "" ? (
                    <>
                    <div className={camApproveLatestStatus=== '0' ? "text-end text-primary" : ( camApproveLatestStatus=== '1' ? "text-end text-success" : "text-end text-red" )}>{showCamNote}</div>

                    { camApproveLatestStatus ==='2' &&(
                      <div className='form-group text-end mb-2'>
                          <button className="btn btn-primary" type="button" onClick={() => handleForApprovalCredit('request','')} disabled={leadId === ''}> Send For Approval </button>
                      </div>
                    )}

                    { camApproveLatestStatus ==='3' &&(
                      <div className='form-group text-end mb-2'>
                          <button className="btn btn-primary" type="button" onClick={() => handleForApprovalCredit('request','')} disabled={leadId === ''}> Send For Re-Approval </button>
                      </div>
                    )}

                  { camApproveLatestStatus ==='1' &&(
                      <div className='form-group text-end mb-2'>
                          <button className="btn btn-danger" type="button"  onClick={() => btnOpenRejectData('3')} disabled={leadId === ''}> Reversal Request </button>
                      </div>
                    )}
                    </>
                ) : ( 
                    <div className='form-group text-end mb-2'>
                        <button className="btn btn-primary" type="button" onClick={() => handleForApprovalCredit('request','')} disabled={leadId === ''}> Send For Approval </button>
                    </div>
                  )
                ) : (
                  <></>
              )} 
    
        { ((userRoleType === 'Credit Head' || userRoleType === 'Superadmin' || userRoleType === 'Super Admin') && camApprovalHistory.length > 0 ) ? (
                  (showCamNote !== "" && camApproveLatestStatus > 0) ? (
                    <div className={camApproveLatestStatus=== '0' ? "text-end text-primary" : ( camApproveLatestStatus=== '1' ? "text-end text-success" : "text-end text-red" )}>{showCamNote}</div>
                ) : ( 
                  <>
                    <div className='form-group text-end mb-2'>
                        <button className="btn btn-success" type="button"  onClick={() => btnOpenRejectData('1')}> Approve </button>&nbsp;
                       
                        <button className="btn btn-danger" type="button" onClick={() => btnOpenRejectData('2')} > Reject </button>
                    </div> 
                    </>
                  )
                ) : (
                  <></>
              )}

            </div>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data" ref={formRef}>

            <div className="tab-content show " id="pills-Cam_tabContent">
              <div className="tab-pane fade show active" id="pills-cam-info" role="tabpanel" aria-labelledby="pills-cam-info-tab" tabIndex="0">
                <ul className="nav nav-pills mb-4" id="pills-tab" role="tablist">
                 

                 <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="pills-customer_dedupe-tab"
                      data-bs-toggle="pill" data-bs-target="#pills-customer_dedupe"
                      type="button" role="tab" aria-controls="pills-customer_dedupe" aria-selected="true"
                    >
                      Customer Dedupe
                    </button>
                  </li>
                 
                  

                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="pills-assets-info-tab" data-bs-toggle="pill" data-bs-target="#pills-assets-info" type="button" role="tab" aria-controls="pills-assets-info" aria-selected="true"> Assets Details</button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="pills-irr-tab" data-bs-toggle="pill" data-bs-target="#pills-irr" type="button" role="tab" aria-controls="pills-irr" aria-selected="true">IRR Sheet</button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="pills-cam_info-tab" data-bs-toggle="pill" data-bs-target="#pills-cam_info" type="button" role="tab" aria-controls="pills-cam_info" aria-selected="true">CAM</button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="pills-disbursement_memo-tab" data-bs-toggle="pill" data-bs-target="#pills-disbursement_memo" type="button" role="tab" aria-controls="pills-disbursement_memo" aria-selected="true">Sanction Terms</button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="pills-banking_info-tab" data-bs-toggle="pill" data-bs-target="#pills-banking_info" type="button" role="tab" aria-controls="pills-banking_info" aria-selected="true">Banking</button>
                  </li>
                  
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="pills-bureau_info-tab" data-bs-toggle="pill" data-bs-target="#pills-bureau_info" type="button" role="tab" aria-controls="pills-bureau_info" aria-selected="true">Bureau</button>
                  </li>

                  
                 {showViability && (
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="pills-visibility_info-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-visibility_info"
                        type="button"
                        role="tab"
                        onClick={() => setActiveTab("viability")}
                      >
                        Viability Sheet
                      </button>
                    </li>
                  )}
                  

                  {(userRoleType === 'Credit Head' || userRoleType === 'Credit' || userRoleType === 'Superadmin' || userRoleType === 'Super Admin')  && (  
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-cam_approval_history-tab" data-bs-toggle="pill" data-bs-target="#pills-cam_approval_history" type="button" role="tab" aria-controls="pills-cam_approval_history" aria-selected="true">Approval History</button>
                      </li>
                      )} 

                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-enach_details-tab" data-bs-toggle="pill" data-bs-target="#pills-enach_details" type="button" role="tab" aria-controls="pills-enach_details" aria-selected="true">E-Nach Details </button>
                      </li>

                      {/* Used Vehicle Tab - Visible only if is_used_loan = 1 */}
                      {parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1 && (
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link"
                            id="pills-used-vehicle-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-used-vehicle"
                            type="button"
                            role="tab"
                            aria-controls="pills-used-vehicle"
                            aria-selected="false"
                          >
                            Used Vehicle
                          </button>
                        </li>
                      )}

                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-fleet_details-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-fleet_details"
                          type="button"
                          role="tab"
                          aria-controls="pills-fleet_details"
                          aria-selected="true"
                          onClick={() => setActiveTab("fleet_details")}
                        >
                          Fleet Details
                        </button>
                      </li>

                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-gst_sheet-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-gst_sheet"
                          type="button"
                          role="tab"
                          aria-controls="pills-gst_sheet"
                          aria-selected="true"
                          onClick={() => setActiveTab("gst_sheet")}
                        >
                          GST Sheet
                        </button>
                      </li>

                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-fleet_viability-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-fleet_viability"
                          type="button"
                          role="tab"
                          aria-controls="pills-fleet_viability"
                          aria-selected="true"
                          onClick={() => setActiveTab("fleet_viability")}
                        >
                          Fleet Viability Sheet
                        </button>
                      </li>

                    <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-financial_sheet-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-financial_sheet"
                          type="button"
                          role="tab"
                          aria-controls="pills-financial_sheet"
                          aria-selected="true"
                          onClick={() => setActiveTab("financial_sheet")}
                        >
                          Financial Sheet
                        </button>
                      </li>
                     
                </ul>

                <div className="tab-content" id="pills-Cam_tabContent">

                   { /* Customer dedupe section : START HERE */ }               
                  <div className="tab-pane fade show active"  id="pills-customer_dedupe" role="tabpanel" aria-labelledby="pills-customer_dedupe-tab" tabIndex="0">
  
                    <div className={camCustomerDedupeLatestStatus=== '0' ? "text-end text-primary" : ( camCustomerDedupeLatestStatus=== '1' ? "text-end text-success" : "text-end text-red" )}>{showCamCustomerDedupeNote}</div>

                    { ((userRoleType === 'CPA' || userRoleType === 'Superadmin' || userRoleType === 'Super Admin') && dedupeMatchesDetails.length > 0 ) ? (
                        (showCamCustomerDedupeNote !== "" && camCustomerDedupeLatestStatus > 0 &&  camCustomerDedupeLatestStatus < 3)  ? (
                          <> 
                          <div className='form-group text-end mb-2'>
                              <button className="btn btn-danger" type="button"  onClick={() => btnOpenDedupeData('3')} disabled={leadId === ''}> Reversal Dedupe Request </button>
                          </div> </>
                      ) : ( 
                        <>
                          <div className='form-group text-end mb-2'>
                              <button className="btn btn-success" type="button"  onClick={() => btnOpenDedupeData('1')}> Approve Dedupe</button>&nbsp;
                            
                              <button className="btn btn-danger" type="button" onClick={() => btnOpenDedupeData('2')} > Reject Dedupe</button>
                          </div> 
                          </>
                        )
                      ) : (
                        <></>
                    )}
 
                    <DedupePage
                          leadInfo={leadInfo}
                          crifDetails={crifDetails}
                          dedupeMatchesDetails={dedupeMatchesDetails}
                          btnOpenDedupeData={btnOpenDedupeData}
                          runCustomerDedupeHistory={runCustomerDedupeHistory}
                        />
                  </div>
                  { /* Customer dedupe section  : END HERE */ } 
                 
                { /* Assets for section : START HERE */ } 
                  <div  className="tab-pane fade first-level" id="pills-assets-info" role="tabpanel" aria-labelledby="pills-assets-info-tab" tabIndex="0">
                    {/* <div className="row"  > */}
                    <div className="col-md-12 mb-3">
                      <button type="button" className="btn btn-primary text-white" onClick={handleToggle} >
                      {showEditAssetSheet ? 'View Format' : 'Edit Format'}
                      </button>
                  </div>  
                   
                  <div className= {showEditAssetSheet ? "row":"row d-none"}  >


                    <div className='col-md-12'>
                          <div className='form-group'>
                            <label htmlFor=" ">
                              <br /> 
                              <h5>Total Amount As Per Perform Invoice : <span className='success-blink float-right'>Rs {totalAmountAsPerPerformInvoice.toFixed(2)}</span></h5>  
                            </label>
                          </div>
                          <hr />
                          </div>

                     { /* <div className="col-md-4" >
                        <div className='form-group' >
                          <label htmlFor="lead-profile" >
                            <span>Address Type </span>
                            <select
                              id='addressTypeId'
                              name='addressTypeId'
                              className="form-select"
                              {...register('addressTypeId')}
                              value={formCAMValues.addressTypeId}
                              onChange={handleCAMChange}

                            >
                              <option value='' > Select Address Type </option>
                              {
                                camCategories.length > 0 && camCategories.map((option) => (
                                  <option value={option.id} >
                                    {option.name}
                                  </option>
                                ))
                              }
                            </select>
                          </label>
                        </div>
                      </div>  */}

                      
                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_no_of_vehicles_to_be_finance">
                            <span>No of Vehicles to be Finance</span>
                            <input
                              type="number"
                              id='assets_no_of_vehicles_to_be_finance'
                              name='assets_no_of_vehicles_to_be_finance'
                              className='form-control'
                              {...register('assets_no_of_vehicles_to_be_finance')}
                              value={formCAMValues.assets_no_of_vehicles_to_be_finance}
                              onChange={handleCAMChange}
                              readOnly="true"
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_chassis_cost_closed_body">
                            <span>Chassis Cost - Closed Body</span>
                            <input
                             type="number"
                              id='assets_chassis_cost_closed_body'
                              name='assets_chassis_cost_closed_body'
                              className='form-control'
                              {...register('assets_chassis_cost_closed_body')}
                              value={formCAMValues.assets_chassis_cost_closed_body}
                              onChange={handleCAMChange}
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_chassis_cost_open_body">
                            <span>Chassis Cost -Open Body</span>
                            <input
                              type="number"
                              id='assets_chassis_cost_open_body'
                              name='assets_chassis_cost_open_body'
                              className='form-control'
                              {...register('assets_chassis_cost_open_body')}
                              value={formCAMValues.assets_chassis_cost_open_body}
                              onChange={handleCAMChange}
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_body_cost_including_gst">
                            <span>Body Cost (If We are Financing) Including GST</span>
                            <input 
                              type="number"
                              id='assets_body_cost_including_gst'
                              name='assets_body_cost_including_gst'
                              className='form-control'
                              {...register('assets_body_cost_including_gst')}
                              value={formCAMValues.assets_body_cost_including_gst}
                              onChange={handleCAMChange}
                              readOnly="true"
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_body_cost_excluding_gst">
                            <span>Body Cost (If We are Financing) Excluding GST</span>
                            <input
                              type="number"
                              id='assets_body_cost_excluding_gst'
                              name='assets_body_cost_excluding_gst'
                              className='form-control'
                              {...register('assets_body_cost_excluding_gst')}
                              value={formCAMValues.assets_body_cost_excluding_gst}
                              onChange={handleCAMChange}
                              readOnly="true"
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_insurance_by_dealer">
                            <span>Insurance by Dealer</span>
                            <input
                              type="number"
                              id='assets_insurance_by_dealer'
                              name='assets_insurance_by_dealer'
                              className='form-control'
                              {...register('assets_insurance_by_dealer')}
                              value={formCAMValues.assets_insurance_by_dealer}
                              onChange={handleCAMChange}
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_insurance_by_customer_ckers">
                            <span>Insurance by Customer/ cKers</span>
                            <input
                              type="number"
                              id='assets_insurance_by_customer_ckers'
                              name='assets_insurance_by_customer_ckers'
                              className='form-control'
                              {...register('assets_insurance_by_customer_ckers')}
                              value={formCAMValues.assets_insurance_by_customer_ckers}
                              onChange={handleCAMChange}
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_handling_charges">
                            <span>Handling Charges @ 5,000 plus 18%</span>
                            <input
                              type="number"
                              id='assets_handling_charges'
                              name='assets_handling_charges'
                              className='form-control'
                              {...register('assets_handling_charges')}
                              value={formCAMValues.assets_handling_charges}
                              onChange={handleCAMChange}
                              readOnly="true"
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_registration_charges_including_gst">
                            <span>Registration Charges (Including GST)</span>
                            <input
                              type="number"
                              id='assets_registration_charges_including_gst'
                              name='assets_registration_charges_including_gst'
                              className='form-control'
                              {...register('assets_registration_charges_including_gst')}
                              value={formCAMValues.assets_registration_charges_including_gst}
                              onChange={handleCAMChange}
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_febrication">
                            <span>FEBRICATION</span>
                            <input
                              type="number"
                              id='assets_febrication'
                              name='assets_febrication'
                              className='form-control'
                              {...register('assets_febrication')}
                              value={formCAMValues.assets_febrication}
                              onChange={handleCAMChange}
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                            <div className='form-group'>
                              <label htmlFor="assets_kli">
                              <span>CLI</span>
                              <input
                                type="number"
                                id='assets_kli'
                                name='assets_kli'
                                className='form-control'
                                {...register('assets_kli')}
                                value={formCAMValues.assets_kli}
                                onChange={handleCAMChange}
                              />
                              </label>
                            </div>
                            </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_amc">
                            <span>AMC</span>
                            <input
                              type="number"
                              id='assets_amc'
                              name='assets_amc'
                              className='form-control'
                              {...register('assets_amc')}
                              value={formCAMValues.assets_amc}
                              onChange={handleCAMChange}
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                            <div className='form-group'>
                              <label htmlFor="assets_gps_device_iot_device_charges">
                              <span>GPS Device / IOT Device Charges</span>
                              <input
                                type="number"
                                id='assets_gps_device_iot_device_charges'
                                name='assets_gps_device_iot_device_charges'
                                className='form-control'
                                {...register('assets_gps_device_iot_device_charges')}
                                value={formCAMValues.assets_gps_device_iot_device_charges}
                                onChange={handleCAMChange}
                                readOnly="true"
                              />
                              </label>
                            </div>
                            </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_charger_cost_hp">
                            <span>Charger Cost(H. P)</span>
                            <input
                              type="number"
                              id='assets_charger_cost_hp'
                              name='assets_charger_cost_hp'
                              className='form-control'
                              {...register('assets_charger_cost_hp')}
                              value={formCAMValues.assets_charger_cost_hp}
                              onChange={handleCAMChange}
                              readOnly="true"
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_other_charges_if_any)">
                            <span>Other Charges (If Any)</span>
                            <input
                              type="number"
                              id='assets_other_charges_if_any'
                              name='assets_other_charges_if_any'
                              className='form-control'
                              {...register('assets_other_charges_if_any')}
                              value={formCAMValues.assets_other_charges_if_any}
                              onChange={handleCAMChange}
                              readOnly="true"
                            />
                            </label>
                          </div>
                          </div>

                          <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="assets_discount">
                            <span>Discount</span>
                            <input
                              type="number"
                              id='assets_discount'
                              name='assets_discount'
                              className='form-control'
                              {...register('assets_discount')}
                              value={formCAMValues.assets_discount}
                              onChange={handleCAMChange}
                            />
                            </label>
                          </div>
                          </div>
                    </div>
                    {!showEditAssetSheet && 
                         <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
                         <tbody>                            
                           <tr>
                               <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Assets Details :</th>
                           </tr>

                           <tr>
                               <td colSpan="6" style={{ textAlign: 'left' }} data-f-bold="true"><b>Total Amount As Per Perform Invoice :</b></td>
                               <td colSpan="6" style={{ textAlign: 'right' }} data-f-bold="true">Rs {totalAmountAsPerPerformInvoice.toFixed(2)}</td>
                           </tr>
                           
                           <tr>
                             <td colSpan="2" data-f-bold="true"><b>No of Vehicles to be Finance :</b></td>
                             <td colSpan="2">{formCAMValues.assets_no_of_vehicles_to_be_finance}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>Chassis Cost - Closed Body :</b></td>
                             <td colSpan="2">{formCAMValues.assets_chassis_cost_closed_body}</td>
                           
                             <td colSpan="2" data-f-bold="true"><b>Chassis Cost -Open Body :</b></td>
                             <td colSpan="2">{formCAMValues.assets_chassis_cost_open_body}</td>
                            </tr>

                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>Body Cost (If We are Financing) Including GST :</b></td>
                             <td colSpan="2">{formCAMValues.assets_body_cost_including_gst}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>Body Cost (If We are Financing) Excluding GST :</b></td>
                             <td colSpan="2">{formCAMValues.assets_body_cost_excluding_gst}</td>
                           
                             <td colSpan="2" data-f-bold="true"><b>Insurance by Dealer :</b></td>
                             <td colSpan="2">{formCAMValues.assets_insurance_by_dealer}</td>
                            </tr>

                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>Insurance by Customer/ cKers :</b></td>
                             <td colSpan="2">{formCAMValues.assets_insurance_by_customer_ckers}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>Handling Charges @ 5,000 plus 18% :</b></td>
                             <td colSpan="2">{formCAMValues.assets_handling_charges}</td>
                           
                             <td colSpan="2" data-f-bold="true"><b>Registration Charges (Including GST) :</b></td>
                             <td colSpan="2">{formCAMValues.assets_registration_charges_including_gst}</td>
                            </tr>

                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>FEBRICATION :</b></td>
                             <td colSpan="2">{formCAMValues.assets_febrication}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>KLI :</b></td>
                             <td colSpan="2">{formCAMValues.assets_kli}</td>
                           
                             <td colSpan="2" data-f-bold="true"><b>AMC :</b></td>
                             <td colSpan="2">{formCAMValues.assets_amc}</td>
                            </tr>

                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>GPS Device / IOT Device Charges :</b></td>
                             <td colSpan="2">{formCAMValues.assets_gps_device_iot_device_charges}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>Charger Cost(H. P) :</b></td>
                             <td colSpan="2">{formCAMValues.assets_charger_cost_hp}</td>
                           
                             <td colSpan="2" data-f-bold="true"><b>Other Charges (If Any) :</b></td>
                             <td colSpan="2">{formCAMValues.assets_other_charges_if_any}</td>
                            </tr>

                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>Discount :</b></td>
                             <td colSpan="10">{formCAMValues.assets_discount}</td>
                            </tr>   
                         </tbody>  
                       </table>
                      }


                  </div>
                  { /* Assets for section : END HERE */ }   

                { /* IRR for section : START HERE */ }
                <div className="tab-pane fade first-level" id="pills-irr" role="tabpanel" aria-labelledby="pills-irr-tab" tabIndex="0">

                      <div className="col-md-12 mb-3">
                        <button type="button" className="btn btn-primary text-white" onClick={handleToggle} >
                          {showEditAssetSheet ? 'View Format' : 'Edit Format'}
                        </button>
                      </div>

                      <div className= {showEditAssetSheet ? "row":"row d-none"}  >
                 
                  <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_total_asset_price">
                        <span>Total Asset Price</span>
                        <input
                          type="number"
                          id='irr_total_asset_price'
                          name='irr_total_asset_price'
                          className='form-control'
                          {...register('irr_total_asset_price')}
                          value={totalAmountAsPerPerformInvoice.toFixed(2)}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_no_of_assets_to_be_financed">
                        <span>No of Assets To be financed</span>
                        <input
                          type="number"
                          id='irr_no_of_assets_to_be_financed'
                          name='irr_no_of_assets_to_be_financed'
                          className='form-control'
                          {...register('irr_no_of_assets_to_be_financed')}
                          value={noOfAssetsToBeFinanced}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_total_value_of_combined_asset">
                        <span>Total Value of Combined Asset</span>
                        <input
                          type="number"
                          id='irr_total_value_of_combined_asset'
                          name='irr_total_value_of_combined_asset'
                          className='form-control'
                          {...register('irr_total_value_of_combined_asset')}
                          value={totalAmountAsPerPerformInvoice.toFixed(2)}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_finance_amount">
                        <span>Finance Amount</span>
                        <input
                          type="number"
                          id='irr_finance_amount'
                          name='irr_finance_amount'
                          className='form-control'
                          {...register('irr_finance_amount')}
                          value={parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1 ? (formCAMValues.used_irr_total_finance_amount || '0.00') : formCAMValues.irr_finance_amount}
                          onChange={handleCAMChange}
                          readOnly={parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1}
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_ltv_percentage">
                        <span>LTV %</span>
                        <input
                          type="number"
                          id='irr_ltv_percentage'
                          name='irr_ltv_percentage'
                          className='form-control'
                          {...register('irr_ltv_percentage')}
                         /* value={iRRLTVPercentage.toFixed(2)} */
                         value={formCAMValues.irr_ltv_percentage}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_flat_rate">
                        <span>Flat Rate %</span>
                        <input
                          type="number"
                          id='irr_flat_rate'
                          name='irr_flat_rate'
                          className='form-control'
                          {...register('irr_flat_rate')}
                          value={formCAMValues.irr_flat_rate}
                          onChange={handleCAMChange}
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_no_of_years">
                        <span>No. of years</span>
                        <input
                          type="number"
                          id='irr_no_of_years'
                          name='irr_no_of_years'
                          className='form-control'
                          {...register('irr_no_of_years')}
                          value={formCAMValues.irr_no_of_years}
                          onChange={handleCAMChange}
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_no_of_emi">
                        <span>No. of EMI</span>
                        <input
                          type="number"
                          id='irr_no_of_emi'
                          name='irr_no_of_emi'
                          className='form-control'
                          {...register('irr_no_of_emi')}
                          value={formCAMValues.irr_no_of_emi}
                          onChange={handleCAMChange}
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_emi_value">
                        <span>EMI Value</span>
                        <input
                          id='irr_emi_value'
                          name='irr_emi_value'
                          className='form-control'
                          {...register('irr_emi_value')}
                          value={iRREMIValue}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_excluding_pf">
                        <span>IRR (Excluding PF)</span>
                        <input
                          id='irr_excluding_pf'
                          name='irr_excluding_pf'
                          className='form-control'
                          {...register('irr_excluding_pf')}
                          value={irrExcludingPF}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_total_interest">
                        <span>Total Interest</span>
                        <input
                          id='irr_total_interest'
                          name='irr_total_interest'
                          className='form-control'
                          {...register('irr_total_interest')}
                          value={iRRTotalInterest.toFixed(2)}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_total_principal">
                        <span>Total Principal</span>
                        <input
                          id='irr_total_principal'
                          name='irr_total_principal'
                          className='form-control'
                          {...register('irr_total_principal')}
                          value={iRRTotalPrincipal}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>

                      <div className='col-md-4'>
                      <div className='form-group'>
                        <label htmlFor="irr_total_repayment">
                        <span>Total Repayment</span>
                        <input
                          id='irr_total_repayment'
                          name='irr_total_repayment'
                          className='form-control'
                          {...register('irr_total_repayment')}
                          value={iRRTotalRepayment}
                          onChange={handleCAMChange}
                          readOnly="true"
                        />
                        </label>
                      </div>
                      </div>


                      </div>
                      {!showEditIRRSheet && 
                         <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
                         <tbody>                            
                           <tr>
                               <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">IRR Sheet Details :</th>
                           </tr>
                           
                           <tr>
                             <td colSpan="2" data-f-bold="true"><b>Total Asset Price :</b></td>
                             <td colSpan="2">{totalAmountAsPerPerformInvoice.toFixed(2)}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>No of Assets To be financed :</b></td>
                             <td colSpan="2">{noOfAssetsToBeFinanced}</td>
                           
                             <td colSpan="2" data-f-bold="true"><b>Total Value of Combined Asset :</b></td>
                             <td colSpan="2">{totalAmountAsPerPerformInvoice.toFixed(2)}</td>
                            </tr>

                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>Finance Amount :</b></td>
                             {/* <td colSpan="2">{formCAMValues.irr_finance_amount}</td> */}
                             <td colSpan="2">{parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1 ? (formCAMValues.used_irr_total_finance_amount || '0.00') : formCAMValues.irr_finance_amount}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>LTV % :</b></td>
                             {/* <td colSpan="2">{iRRLTVPercentage.toFixed(2)}</td> */}
                             <td colSpan="2">{Number.isFinite(iRRLTVPercentage) ? iRRLTVPercentage.toFixed(2) : "0.00"}</td>


           
                             <td colSpan="2" data-f-bold="true"><b>Flat Rate % :</b></td>
                             <td colSpan="2">{formCAMValues.irr_flat_rate}</td>
                            </tr>

                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>No. of years :</b></td>
                             <td colSpan="2">{formCAMValues.irr_no_of_years}</td>
                           
                             <td colSpan="2" data-f-bold="true"><b>No. of EMI :</b></td>
                             <td colSpan="2">{formCAMValues.irr_no_of_emi}</td>
                           
                             <td colSpan="2" data-f-bold="true"><b>EMI Value :</b></td>
                             <td colSpan="2">{iRREMIValue}</td>
                            </tr>
           
                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>IRR (Excluding PF) :</b></td>
                             <td colSpan="2">{irrExcludingPF}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>Total Interest :</b></td>
                             <td colSpan="2">{iRRTotalInterest.toFixed(2)}</td>
           
                             <td colSpan="2" data-f-bold="true"><b>Total Principal :</b></td>
                             <td colSpan="2">{iRRTotalPrincipal}</td>
                            </tr>

                            <tr>
                             <td colSpan="2" data-f-bold="true"><b>Total Repayment :</b></td>
                             <td colSpan="10">{iRRTotalRepayment}</td>
                           </tr>                
                         </tbody>
                       </table>
                      }

                  {/* Used Loan / Fleet IRR Sheet - additional fields, shown below the regular
                      IRR fields above (not replacing them) when is_used_loan = 1.
                      Formulas/useEffect calculations remain exactly as before - only the
                      layout changed so both sets of fields are visible together. */}
                  {parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1 && (
                    <>
                      <hr
                        style={{
                          width: 'calc(100% + 30px)',
                          marginLeft: '-15px',
                          marginRight: '-15px',
                          // marginTop: '35px',
                          // marginBottom: '15px',
                          border: 'none',
                          borderTop: '1px solid #0000003d',
                          opacity: 1,
                        }}
                      />
                      {/* <div className="col-md-12 mb-3 mt-5">
                        <h5>Used Loan / Fleet IRR Sheet (Additional Fields)</h5>
                      </div> */}

                      <div className="row">
                        {/* Chassis Cost (Deal Close) - HIDDEN for now (not in use), value still mirrored internally, kept via false-guard so easy to re-enable later */}
                        {false && (
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_chassis_cost_deal_close">
                              <span>Chassis Cost (Deal Close)</span>
                              <input
                                type="number"
                                id='used_irr_chassis_cost_deal_close'
                                name='used_irr_chassis_cost_deal_close'
                                className='form-control'
                                {...register('used_irr_chassis_cost_deal_close')}
                                value={formCAMValues.used_irr_chassis_cost_deal_close || '0.00'}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>
                        )}

                        {/* Insurance by Customer / cKers - HIDDEN for now (not in use), value still mirrored internally, kept via false-guard so easy to re-enable later */}
                        {false && (
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_insurance_by_customer_ckers">
                              <span>Insurance by Customer / cKers</span>
                              <input
                                type="number"
                                id='used_irr_insurance_by_customer_ckers'
                                name='used_irr_insurance_by_customer_ckers'
                                className='form-control'
                                {...register('used_irr_insurance_by_customer_ckers')}
                                value={formCAMValues.used_irr_insurance_by_customer_ckers || '0.00'}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>
                        )}

                        {/* DP/Margin - input, feeds irr_finance_amount formula above */}
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_dp_margin">
                              <span>DP/Margin</span>
                              <input
                                type="number"
                                id='used_irr_dp_margin'
                                name='used_irr_dp_margin'
                                className='form-control'
                                {...register('used_irr_dp_margin')}
                                value={formCAMValues.used_irr_dp_margin}
                                onChange={handleCAMChange}
                                step="0.01"
                              />
                            </label>
                          </div>
                        </div>

                        {/* CLI Amount */}
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="cam_kotak_li_amount">
                              <span>CLI Amount on considering loan amount</span>
                              <input
                                type="number"
                                id='cam_kotak_li_amount'
                                name='cam_kotak_li_amount'
                                className='form-control'
                                {...register('cam_kotak_li_amount')}
                                value={formCAMValues.cam_kotak_li_amount}
                                onChange={handleCAMChange}
                              />
                            </label>
                          </div>
                        </div>

                        {/* Considering Loan Amount - read-only reference field, not a saved input.
                            Value = Total Asset Price - DP/Margin (formCAMValues.irr_finance_amount
                            already holds this via the existing "Considering Loan Amount" useEffect). */}
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="considering_loan_amount_display">
                              <span>Considering Loan Amount</span>
                              <input
                                type="text"
                                id='considering_loan_amount_display'
                                className='form-control'
                                value={formCAMValues.irr_finance_amount || '0.00'}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>

                        {/* Total Finance Amount - HIDDEN, value ab upar "Finance Amount" field mein hi dikh raha hai (fleet case) */}
                        {false && (
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_total_finance_amount">
                              <span>Total Finance Amount</span>
                              <input
                                type="number"
                                id='used_irr_total_finance_amount'
                                name='used_irr_total_finance_amount'
                                className='form-control'
                                {...register('used_irr_total_finance_amount')}
                                value={formCAMValues.used_irr_total_finance_amount}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>
                        )}

                        {/* PF Fund in LA - calculated */}
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_pf_fund_in_la">
                              <span>PF 2% of Total Finance Amount (Including GST) - Fund in LA</span>
                              <input
                                type="number"
                                id='used_irr_pf_fund_in_la'
                                name='used_irr_pf_fund_in_la'
                                className='form-control'
                                {...register('used_irr_pf_fund_in_la')}
                                value={formCAMValues.used_irr_pf_fund_in_la}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>

                        {/* Documents charges - Fund in LA */}
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="cam_file_charges">
                              <span>Documents charges - Fund in LA</span>
                              <input
                                type="number"
                                id='cam_file_charges'
                                name='cam_file_charges'
                                className='form-control'
                                {...register('cam_file_charges')}
                                value={formCAMValues.cam_file_charges}
                                onChange={handleCAMChange}
                                step="0.01"
                              />
                            </label>
                          </div>
                        </div>

                        {/* Revised Loan Amount - calculated */}
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_revised_loan_amount">
                              <span>New (Revised) Loan Amount (Including DC+PF and CLI fund)</span>
                              <input
                                type="number"
                                id='used_irr_revised_loan_amount'
                                name='used_irr_revised_loan_amount'
                                className='form-control'
                                {...register('used_irr_revised_loan_amount')}
                                value={formCAMValues.used_irr_revised_loan_amount}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>

                        {/* Adjust PF% as per old Loan Amount - calculated */}
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_adjust_pf_old_loan">
                              <span>Adjust PF% as per old Loan Amount (Rs.)</span>
                              <input
                                type="number"
                                id='used_irr_adjust_pf_old_loan'
                                name='used_irr_adjust_pf_old_loan'
                                className='form-control'
                                {...register('used_irr_adjust_pf_old_loan')}
                                value={formCAMValues.used_irr_adjust_pf_old_loan}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>

                        {/* PF% - HIDDEN, not needed anymore */}
                        {false && (
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_pf_percentage">
                              <span>PF% (Open Field)</span>
                              <input
                                type="number"
                                id='used_irr_pf_percentage'
                                name='used_irr_pf_percentage'
                                className='form-control'
                                {...register('used_irr_pf_percentage')}
                                value={formCAMValues.used_irr_pf_percentage}
                                onChange={handleCAMChange}
                                step="0.000001"
                                placeholder="e.g., 0.02 for 2%"
                              />
                            </label>
                          </div>
                        </div>
                        )}

                        {/* PF in Amount - HIDDEN, not needed anymore */}
                        {false && (
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_pf_amount">
                              <span>PF in Amount (Open Field)</span>
                              <input
                                type="number"
                                id='used_irr_pf_amount'
                                name='used_irr_pf_amount'
                                className='form-control'
                                {...register('used_irr_pf_amount')}
                                value={formCAMValues.used_irr_pf_amount}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>
                        )}

                        {/* GST - HIDDEN, not needed anymore */}
                        {false && (
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_gst_amount">
                              <span>GST (18%)</span>
                              <input
                                type="number"
                                id='used_irr_gst_amount'
                                name='used_irr_gst_amount'
                                className='form-control'
                                {...register('used_irr_gst_amount')}
                                value={formCAMValues.used_irr_gst_amount}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>
                        )}

                        {/* Total PF in amount - HIDDEN, not needed anymore */}
                        {false && (
                        <div className='col-md-4'>
                          <div className='form-group'>
                            <label htmlFor="used_irr_total_pf_amount">
                              <span>Total PF in amount</span>
                              <input
                                type="number"
                                id='used_irr_total_pf_amount'
                                name='used_irr_total_pf_amount'
                                className='form-control'
                                {...register('used_irr_total_pf_amount')}
                                value={formCAMValues.used_irr_total_pf_amount}
                                readOnly
                                style={{ backgroundColor: '#f0f0f0' }}
                              />
                            </label>
                          </div>
                        </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
                { /* IRR for section : END HERE */ }                

                 { /* CAM for section : START HERE */ }               
                  <div className="tab-pane fade first-level" id="pills-cam_info" role="tabpanel" aria-labelledby="pills-cam_info-tab" tabIndex="0">
                     
                   <CustomerAssessmentNotePage
                             leadInfo={leadInfo}
                             formCAMValues={formCAMValues}
                             fetchLeads={fetchLeads}
                             formCAMRSMRHCHValues={formCAMRSMRHCHValues}
                             anchorCategories={anchorCategories} 
                             speciallyAbledArr={speciallyAbledArr}
                             handleCAMChange ={handleCAMChange}  
                             handleCAMRSMRHCHChange ={handleCAMRSMRHCHChange}
                            handleRSMRHCHDetails ={handleRSMRHCHDetails} 
                            rsmRhChLatestHistoryData ={rsmRhChLatestHistoryData} 
                             preloaderStatus ={preloaderStatus}  
                             userRoleType ={userRoleType}      
                             residenceTypesArr ={residenceTypesArr}  
                             bankingUpiArr ={bankingUpiArr} 
                             drivingLicenseTypeMasterArr ={drivingLicenseTypeMasterArr} 
                             constitutionArr={constitutionArr} 
                             customerTypeArr={customerTypeArr} 
                             vehicleMakerArr={vehicleMakerArr} 
                             vehicleUseArr={vehicleUseArr} 
                             insuranceArr={insuranceArr} 
                             vehicleModelsArr={vehicleModelsArr} 
                             setCamTotalPFAmount={setCamTotalPFAmount} 
                             camTotalPFAmount={camTotalPFAmount} 
                             coapplicantGuarantorRows={coapplicantGuarantorRows}
                             handleInputChange={handleInputChange}  
                             businessValidationProofArr={businessValidationProofArr}  
                             turnoverIncomeArr= {turnoverIncomeArr} 
                             workingCapitalCycleArr={workingCapitalCycleArr}  
                             accountTypeArr={accountTypeArr} 
                             requirementOptions={requirementOptions} 
                             statusOptions={statusOptions}  
                             normsMetOptions={normsMetOptions}  
                             setCAMLTVPercentage={setCAMLTVPercentage} 
                             cAMLTVPercentage={cAMLTVPercentage}
                             setCAMMarginMoney={setCAMMarginMoney}   
                             cAMMarginMoney={cAMMarginMoney} 
                             setCamIRRExcludingPF={setCamIRRExcludingPF}   
                             camIRRExcludingPF={camIRRExcludingPF}  
                             irrExcludingPF={irrExcludingPF}
                             totalValueCombine={totalValueCombine}
                             totalAmountAsPerPerformInvoice={totalAmountAsPerPerformInvoice}
                             allDealersArr={allDealersArr} 
                              dealerName={dealerName} 
                              autoUpdateField={autoUpdateField}
                              
                             />
                  </div>
                  { /* CAM for section : END HERE */ } 

                  { /* Disbursement memo for section : START HERE */ }               
                  <div className="tab-pane fade first-level" id="pills-disbursement_memo" role="tabpanel" aria-labelledby="pills-disbursement_memo-tab" tabIndex="0">
                     
                   <DisbursementMemoPage
                             leadInfo={leadInfo}
                             formCAMValues={formCAMValues}
                             anchorCategories={anchorCategories} 
                             speciallyAbledArr={speciallyAbledArr}
                             handleCAMChange ={handleCAMChange}  
                             residenceTypesArr ={residenceTypesArr}  
                             bankingUpiArr ={bankingUpiArr}
                             drivingLicenseTypeMasterArr ={drivingLicenseTypeMasterArr}  
                             constitutionArr={constitutionArr} 
                             customerTypeArr={customerTypeArr} 
                             vehicleMakerArr={vehicleMakerArr} 
                             vehicleUseArr={vehicleUseArr} 
                             insuranceArr={insuranceArr} 
                             vehicleModelsArr={vehicleModelsArr} 
                             setCamTotalPFAmount={setCamTotalPFAmount} 
                             camTotalPFAmount={camTotalPFAmount} 
                             coapplicantGuarantorRows={coapplicantGuarantorRows}
                             handleInputChange={handleInputChange}  
                             businessValidationProofArr={businessValidationProofArr}  
                             turnoverIncomeArr= {turnoverIncomeArr} 
                             workingCapitalCycleArr={workingCapitalCycleArr}  
                             accountTypeArr={accountTypeArr} 
                             requirementOptions={requirementOptions} 
                             statusOptions={statusOptions}  
                             normsMetOptions={normsMetOptions}  
                             setCAMLTVPercentage={setCAMLTVPercentage} 
                             cAMLTVPercentage={cAMLTVPercentage}
                             setCAMMarginMoney={setCAMMarginMoney}   
                             cAMMarginMoney={cAMMarginMoney} 
                             setCamIRRExcludingPF={setCamIRRExcludingPF}   
                             camIRRExcludingPF={camIRRExcludingPF}  
                             irrExcludingPF={irrExcludingPF}
                             totalValueCombine={totalValueCombine}
                             totalAmountAsPerPerformInvoice={totalAmountAsPerPerformInvoice} 
                             allDealersArr={allDealersArr}   
                             />
                  </div>
                  { /* Disbursement memo for section : END HERE */ } 


                  { /* Banking info for section : START HERE */ }               
                  <div className="tab-pane fade first-level" id="pills-banking_info" role="tabpanel" aria-labelledby="pills-banking_info-tab" tabIndex="0">
                       <CamBankingPage
                             leadInfo={leadInfo} 
                             bankDetails={bankDetails}
                            />
                  </div>
                  { /* Banking info for section : END HERE */ } 

                 
                  { /* Bureau info for section : START HERE */ }               
                  <div className="tab-pane fade first-level" id="pills-bureau_info" role="tabpanel" aria-labelledby="pills-bureau_info-tab" tabIndex="0">
                        <CamBureauPage
                             leadInfo={leadInfo}
                             crifDetails={crifDetails}
                            />
                  </div>
                  { /* Bureau info for section : END HERE */ } 


                  { /* Visibility info for section : START HERE */ } 
                  <div className="tab-pane fade first-level" id="pills-visibility_info" role="tabpanel" aria-labelledby="pills-visibility_info-tab" tabIndex="0">
                        <CamVisibilityPage
                             leadInfo={leadInfo}
                             crifDetails={crifDetails}
                             leadpostdata={leadpostdata}
                            />
                  </div>
                  {/* Visibility info for section : End HERE */}                 

                   { /* Cam approval history for section : START HERE */ }               
                  <div className="tab-pane fade first-level" id="pills-cam_approval_history" role="tabpanel" aria-labelledby="pills-cam_approval_history-tab" tabIndex="0">
                        <CamApprovalHistoryPage
                             leadInfo={leadInfo}
                             crifDetails={crifDetails}
                             setCamApprovalHistory={setCamApprovalHistory}
                             camApprovalHistory={camApprovalHistory}
                            />
                  </div>
                  { /* Cam approval history for section : END HERE */ }   
                   
                   <div className="tab-pane fade first-level" id="pills-enach_details" role="tabpanel" aria-labelledby="pills-enach_details-tab" tabIndex="0">
                        <CamEnachDetailsPage leadId={id ? atob(id) : ''} />
                  </div>
 
                  {/* Used Vehicle Tab Content - Visible only if is_used_loan = 1 */}
                  {parseInt(leadInfo?.data?.[0]?.is_used_loan, 10) === 1 && (
                    <div
                      className="tab-pane fade first-level"
                      id="pills-used-vehicle"
                      role="tabpanel"
                      aria-labelledby="pills-used-vehicle-tab"
                      tabIndex="0"
                    >
                      <UsedVehiclePage leadId={id ? atob(id) : ''} />
                    </div>
                  )}
                  <div className="tab-pane fade first-level" id="pills-fleet_details" role="tabpanel" aria-labelledby="pills-fleet_details-tab" tabIndex="0">
                        <FleetDetails leadId={id ? atob(id) : ''} leadInfo={leadInfo} />
                  </div>

                  <div className="tab-pane fade first-level" id="pills-gst_sheet" role="tabpanel" aria-labelledby="pills-gst_sheet-tab" tabIndex="0">
                        <GstSheet leadId={id ? atob(id) : ''} leadInfo={leadInfo} />
                  </div>

                  <div className="tab-pane fade first-level" id="pills-fleet_viability" role="tabpanel" aria-labelledby="pills-fleet_viability-tab" tabIndex="0">
                        <FleetViability leadId={id ? atob(id) : ''} leadInfo={leadInfo} />
                  </div>

                  <div className="tab-pane fade first-level" id="pills-financial_sheet" role="tabpanel" aria-labelledby="pills-financial_sheet-tab" tabIndex="0">
                        <FinancialSheet leadId={id ? atob(id) : ''} leadInfo={leadInfo} />
                  </div>

                </div>
              </div>
            </div> 

            <div className="row mt-5">
              <div className="row mt-5">
                <div className="col-md-12">
                  <div className="form-group mb-0">
                    {/* <button className="btn btn-primary">Submit</button>  */}

                  { ( userRoleType === "User" || 
                        userRoleType === "Regional Sales Manager" || 
                        userRoleType === "Regional Head" || 
                        userRoleType === "Cluster Head" ||
                        activeTab === "viability" ||
                        activeTab === "fleet_details" ||
                        activeTab === "gst_sheet" ||
                        activeTab === "fleet_viability" ||
                        activeTab === "financial_sheet" ||
                        document.getElementById("pills-communication-mail")?.classList.contains("active")
                      ) ? (
                    <> &nbsp; </>
                  ) : (
                    // hasAddPermission && (
                    <button className={showEditIRRSheet || showEditAssetSheet ? "row btn btn-primary":" d-none"}>
                      Submit
                    </button>    
                    // )
                  )}            

                  </div>
                </div>
              </div>
            </div>
          </form> 
        </div>
      </div>

      {/* Camera Modal */}
        {showCameraModal && (
          <div style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)",
            display: "flex", flexDirection: "column", alignItems: "center",
            justifyContent: "center", zIndex: 99999, padding: "20px"
          }}>
            <video ref={videoRef} autoPlay playsInline muted
              style={{ width: "100%", maxWidth: "480px", borderRadius: "12px",
                background: "#000", maxHeight: "60vh" }}
            >
              <track kind="captions" />
            </video>
            <div style={{ display: "flex", gap: "16px", marginTop: "20px" }}>
              <button className="btn btn-success btn-lg" type="button" onClick={capturePhoto}>
                📸 Capture
              </button>
              <button className="btn btn-danger btn-lg" type="button" onClick={stopCamera}>
                ✕ Cancel
              </button>
            </div>
          </div>
        )}


      {/* Reject REGISTRATION MODAL START */}
      <Modal open={openRejectAmt} onClose={handleCloseRejectAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <div className='modal-custom rounded'>
              <div className='modal-head'>
                <h4 id="modal-title">Enter Notes </h4>
                <Button onClick={handleCloseRejectAmt} color="primary" className='btn'>
                  <i className="bi bi-x"> &nbsp;</i>
                </Button>
              </div>

              <div className='modal-body'>
                <form onSubmit={handleSubmit(handleRejectFormSubmit)} encType="multipart/form-data">
                  <div className="row mx-0">
                    
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="itr_file">
                          <span>Notes <a style={{ color: "red" }}>*</a></span> 
                            < textarea
                                id='notes'
                                name='notes'
                                className='form-control'
                                {...register('notes')}
                                 onChange={handleAmtRejectChange}
                               
                            />
</label>
                      </div>
                    </div>

                

                    <div className="col-md-12">
                      <div className="form-group mb-0">
                        <button className="btn btn-primary mt-2">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
        {/* Reject REGISTRATION MODAL END */}


        {/* Dedupe MODAL START */}
      <Modal open={openDedupe} onClose={handleCloseDedupe} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <div className='modal-custom rounded'>
              <div className='modal-head'>
                <h4 id="modal-title">Enter Notes </h4>
                <Button onClick={handleCloseDedupe} color="primary" className='btn'>
                  <i className="bi bi-x"> &nbsp;</i>
                </Button>
              </div>

              <div className='modal-body'>
                <form onSubmit={handleSubmit(handleDedupeFormSubmit)} encType="multipart/form-data">
                  <div className="row mx-0">
                    
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="itr_file">
                          <span>Notes <a style={{ color: "red" }}>*</a></span> 
                            < textarea
                                id='notes'
                                name='notes'
                                className='form-control'
                                {...register('notes')}
                                 onChange={handleAmtDedupeChange}
                               
                            />
</label>
                      </div>
                    </div>

                

                    <div className="col-md-12">
                      <div className="form-group mb-0">
                        <button className="btn btn-primary mt-2">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
        {/* Dedupe MODAL END */}

        <Modal
        open={openMailModal}
        onClose={()=>
        setOpenMailModal(false)
        }
        >

        <div
        style={{
        position:"fixed",
        inset:0,
        background:"rgba(0,0,0,.45)",
        backdropFilter:"blur(4px)",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        padding:"20px",
        zIndex:9999
        }}
        >

        <div
        style={{
        width:"700px",
        maxWidth:"95%",
        maxHeight:"85vh",
        background:"#fff",
        borderRadius:"20px",
        overflow:"hidden",
        boxShadow:
        "0 20px 60px rgba(0,0,0,.18)"
        }}
        >

        {/* HEADER */}

        <div
        style={{
        padding:"18px 24px",
        borderBottom:"1px solid #eee",
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center",
        background:"#fafbfd"
        }}
        >

        <div>

        <div
        style={{
        fontSize:"22px",
        fontWeight:"700",
        color:"#111"
        }}
        >

        📩 Mail Body

        </div>

        <div
        style={{
        fontSize:"13px",
        color:"#777",
        marginTop:"3px"
        }}
        >

        Communication Content

        </div>

        </div>

        <button
        onClick={()=>
        setOpenMailModal(false)
        }
        style={{
        border:"none",
        width:"36px",
        height:"36px",
        borderRadius:"50%",
        background:"#f3f4f6",
        fontSize:"18px",
        cursor:"pointer"
        }}
        >

        ✕

        </button>

        </div>

        {/* BODY */}

        <div
        style={{
        padding:"24px",
        maxHeight:"55vh",
        overflowY:"auto"
        }}
        >

        <div
        style={{
        background:"#f8fafc",
        padding:"20px",
        borderRadius:"14px",
        border:"1px solid #edf1f7",
        fontSize:"15px",
        lineHeight:"1.8",
        color:"#333"
        }}
        dangerouslySetInnerHTML={{
        __html:
        selectedMailBody ||
        "<p>-</p>"
        }}
        />

        {JSON.parse(selectedMailDocuments || "[]").length > 0 && (
          <div style={{ marginTop: "25px" }}>
            <h6
              style={{
                fontWeight: 700,
                marginBottom: 18,
                fontSize: 18
              }}
            >
              📎 Attachments
            </h6>

            {/* Scrollable Attachment Area */}
            <div
              style={{
                maxHeight: "250px",
                overflowY: "auto",
                overflowX: "hidden",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                padding: "15px",
                background: "#fafafa"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "15px"
                }}
              >
                {JSON.parse(selectedMailDocuments || "[]").map((file, index) => {
                  const fileUrl = `${config.API_BASE_URL}uploads/communication/${file}`;

                  const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(file);

                  return isImage ? (
                    <div
                      key={index}
                      style={{
                        width: "150px",
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        overflow: "hidden",
                        background: "#fff",
                        boxShadow: "0 2px 8px rgba(0,0,0,.08)"
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => setPreviewImage(fileUrl)}
                        style={{
                          border: "none",
                          padding: 0,
                          background: "transparent",
                          cursor: "pointer",
                          width: "100%"
                        }}
                      >
                        <img
                          src={fileUrl}
                          alt="Attachment"
                          style={{
                            width: "100%",
                            height: "120px",
                            objectFit: "cover"
                          }}
                        />
                      </button>

                      <div
                        style={{
                          padding: "10px",
                          textAlign: "center"
                        }}
                      >
                        <a
                          href={fileUrl}
                          download
                          className="btn btn-success btn-sm"
                          style={{
                            width: "100%"
                          }}
                        >
                          View
                        </a>
                      </div>
                    </div>
                  ) : (
                    <div
                      key={index}
                      style={{
                        width: "220px",
                        padding: "15px",
                        border: "1px solid #ddd",
                        borderRadius: "12px",
                        background: "#fff"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "12px"
                        }}
                      >
                        <i
                          className="bi bi-file-earmark-text"
                          style={{
                            fontSize: "30px",
                            color: "#2563eb"
                          }}
                        />

                        <div
                          style={{
                            fontSize: "13px",
                            wordBreak: "break-word"
                          }}
                        >
                          {file}
                        </div>
                      </div>

                      <a
                        href={fileUrl}
                        download
                        className="btn btn-primary btn-sm"
                        style={{
                          width: "100%"
                        }}
                      >
                        Download
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        </div>
        {/* ATTACHMENTS */}


        {/* FOOTER */}

        <div
        style={{
        padding:"16px 24px",
        borderTop:"1px solid #eee",
        display:"flex",
        justifyContent:"flex-end"
        }}
        >

        <button
        className="btn btn-dark"
        style={{
        borderRadius:"10px",
        padding:"8px 22px",
        fontWeight:"600"
        }}
        onClick={()=>
        setOpenMailModal(false)
        }
        >

        Close

        </button>

        </div>

        </div>

        </div>

        </Modal>
        <Modal
            open={!!previewImage}
            onClose={() => setPreviewImage("")}
        >

        <div
            role="button"
            tabIndex={0}
            onClick={() => setPreviewImage("")}
            onKeyDown={(e) => {
                if (e.key === "Escape" || e.key === "Enter") {
                    setPreviewImage("");
                }
            }}
            style={{
                position:"fixed",
                inset:0,
                background:"rgba(0,0,0,.85)",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
            }}
        >

        <img
            src={previewImage}
            alt="Preview"
            role="presentation"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
                maxWidth:"90%",
                maxHeight:"90%",
                borderRadius:"10px"
            }}
        />

        <a
            href={previewImage}
            download
            className="btn btn-success"
            style={{
                position:"absolute",
                top:20,
                right:70
            }}
        >
            View
        </a>

        <button
            onClick={()=>setPreviewImage("")}
            style={{
                position:"absolute",
                top:20,
                right:20,
                width:"40px",
                height:"40px",
                border:"none",
                borderRadius:"50%",
                background:"#fff",
                cursor:"pointer",
                fontSize:"18px"
            }}
        >
        ✕
        </button>

        </div>

        </Modal>
    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CamPage);